/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as ForcePasswordChangeRouteImport } from './routes/force-password-change'
import { Route as MaintenanceRouteImport } from './routes/maintenance'
import { Route as AuthIndexRouteImport } from './routes/_auth/index'
import { Route as AuthApprovalsRouteImport } from './routes/_auth/approvals'
import { Route as AuthInstructionsRouteImport } from './routes/_auth/instructions'
import { Route as AuthOperationsRouteImport } from './routes/_auth/operations'
import { Route as AuthPayoutsRouteImport } from './routes/_auth/payouts'
import { Route as PublicAppsRouteImport } from './routes/_public/apps'
import { Route as PublicForgotPasswordRouteImport } from './routes/_public/forgot-password'
import { Route as PublicLoginRouteImport } from './routes/_public/login'
import { Route as PublicPrivacyRouteImport } from './routes/_public/privacy'
import { Route as PublicResetPasswordRouteImport } from './routes/_public/reset-password'
import { Route as PublicTermsRouteImport } from './routes/_public/terms'
import { Route as AuthAccountingAccountsRouteImport } from './routes/_auth/accounting/accounts'
import { Route as AuthAccountingCommissionRouteImport } from './routes/_auth/accounting/commission'
import { Route as AuthAccountingPeriodsRouteImport } from './routes/_auth/accounting/periods'
import { Route as AuthAdminConfigRouteImport } from './routes/_auth/admin/config'
import { Route as AuthAdminHealthRouteImport } from './routes/_auth/admin/health'
import { Route as AuthAdminMaintenanceRouteImport } from './routes/_auth/admin/maintenance'
import { Route as AuthAgentsIndexRouteImport } from './routes/_auth/agents/index'
import { Route as AuthAgentsIdRouteImport } from './routes/_auth/agents/$id'
import { Route as AuthAgentsNewRouteImport } from './routes/_auth/agents/new'
import { Route as AuthAuctionsIndexRouteImport } from './routes/_auth/auctions/index'
import { Route as AuthAuditIndexRouteImport } from './routes/_auth/audit/index'
import { Route as AuthComplianceSubscriberRegisterRouteImport } from './routes/_auth/compliance/subscriber-register'
import { Route as AuthCrmIdRouteImport } from './routes/_auth/crm/$id'
import { Route as AuthCrmConvertedRouteImport } from './routes/_auth/crm/converted'
import { Route as AuthCrmLeadsRouteImport } from './routes/_auth/crm/leads'
import { Route as AuthCrmLostRouteImport } from './routes/_auth/crm/lost'
import { Route as AuthCrmNewRouteImport } from './routes/_auth/crm/new'
import { Route as AuthCrmProspectsRouteImport } from './routes/_auth/crm/prospects'
import { Route as AuthCustomersIndexRouteImport } from './routes/_auth/customers/index'
import { Route as AuthCustomersIdRouteImport } from './routes/_auth/customers/$id'
import { Route as AuthCustomersNewRouteImport } from './routes/_auth/customers/new'
import { Route as AuthDefaultsIndexRouteImport } from './routes/_auth/defaults/index'
import { Route as AuthDefaultsIdRouteImport } from './routes/_auth/defaults/$id'
import { Route as AuthFinanceCashVaultRouteImport } from './routes/_auth/finance/cash-vault'
import { Route as AuthFinanceHandoversRouteImport } from './routes/_auth/finance/handovers'
import { Route as AuthFinanceReceiptsRouteImport } from './routes/_auth/finance/receipts'
import { Route as AuthFinanceRunningReceiptsRouteImport } from './routes/_auth/finance/running-receipts'
import { Route as AuthForeclosureIndexRouteImport } from './routes/_auth/foreclosure/index'
import { Route as AuthLedgerAccountIdRouteImport } from './routes/_auth/ledger.$accountId'
import { Route as AuthLogsAuthRouteImport } from './routes/_auth/logs/auth'
import { Route as AuthLogsNotificationsRouteImport } from './routes/_auth/logs/notifications'
import { Route as AuthOverdueIndexRouteImport } from './routes/_auth/overdue/index'
import { Route as AuthPidiSchemesIndexRouteImport } from './routes/_auth/pidi-schemes/index'
import { Route as AuthPidiSchemesIdRouteImport } from './routes/_auth/pidi-schemes/$id'
import { Route as AuthPidiSchemesNewRouteImport } from './routes/_auth/pidi-schemes/new'
import { Route as AuthReconciliationImportIdRouteImport } from './routes/_auth/reconciliation/$importId'
import { Route as AuthReportsIndexRouteImport } from './routes/_auth/reports/index'
import { Route as AuthReportsCodeRouteImport } from './routes/_auth/reports.$code'
import { Route as AuthReportsArrearsRouteImport } from './routes/_auth/reports/arrears'
import { Route as AuthReportsDaybookRouteImport } from './routes/_auth/reports/daybook'
import { Route as AuthReportsSubscriberLedgerRouteImport } from './routes/_auth/reports/subscriber-ledger'
import { Route as AuthSchemesIndexRouteImport } from './routes/_auth/schemes/index'
import { Route as AuthSchemesIdRouteImport } from './routes/_auth/schemes/$id'
import { Route as AuthSchemesEstimateRouteImport } from './routes/_auth/schemes/estimate'
import { Route as AuthSchemesNewRouteImport } from './routes/_auth/schemes/new'
import { Route as AuthSchemesTransfersRouteImport } from './routes/_auth/schemes/transfers'
import { Route as AuthSettingsBranchesRouteImport } from './routes/_auth/settings/branches'
import { Route as AuthSettingsMpinRouteImport } from './routes/_auth/settings/mpin'
import { Route as AuthSettingsPasswordRouteImport } from './routes/_auth/settings/password'
import { Route as AuthSettingsRolesRouteImport } from './routes/_auth/settings/roles'
import { Route as AuthSettingsSecurityRouteImport } from './routes/_auth/settings/security'
import { Route as AuthSettingsSessionsRouteImport } from './routes/_auth/settings/sessions'
import { Route as AuthSetupCompanyRouteImport } from './routes/_auth/setup/company'
import { Route as AuthSuretyIndexRouteImport } from './routes/_auth/surety/index'
import { Route as AuthTaxIndexRouteImport } from './routes/_auth/tax/index'
import { Route as AuthTemplatesIndexRouteImport } from './routes/_auth/templates/index'
import { Route as AuthTemplatesIdRouteImport } from './routes/_auth/templates/$id'
import { Route as AuthTemplatesNewRouteImport } from './routes/_auth/templates/new'
import { Route as AuthUsersIndexRouteImport } from './routes/_auth/users/index'
import { Route as AuthUsersIdRouteImport } from './routes/_auth/users/$id'
import { Route as AuthUsersNewRouteImport } from './routes/_auth/users/new'
import { Route as AuthAccountingGeneralTransactionsIndexRouteImport } from './routes/_auth/accounting/general-transactions/index'
import { Route as AuthAccountingGeneralTransactionsNewRouteImport } from './routes/_auth/accounting/general-transactions/new'
import { Route as AuthAccountingJournalIndexRouteImport } from './routes/_auth/accounting/journal/index'
import { Route as AuthAdminProductsIndexRouteImport } from './routes/_auth/admin/products/index'
import { Route as AuthAdminProductsNewRouteImport } from './routes/_auth/admin/products/new'
import { Route as AuthAdminStaffIndexRouteImport } from './routes/_auth/admin/staff/index'
import { Route as AuthAdminStaffIdRouteImport } from './routes/_auth/admin/staff/$id'
import { Route as AuthAdminStaffNewRouteImport } from './routes/_auth/admin/staff/new'
import { Route as AuthFinanceAdvancesIndexRouteImport } from './routes/_auth/finance/advances/index'
import { Route as AuthFinanceAdvancesNewRouteImport } from './routes/_auth/finance/advances/new'
import { Route as AuthFinanceChequeRegisterIndexRouteImport } from './routes/_auth/finance/cheque-register/index'
import { Route as AuthFinanceChequeRegisterNewRouteImport } from './routes/_auth/finance/cheque-register/new'
import { Route as AuthFinanceChitActFeesIndexRouteImport } from './routes/_auth/finance/chit-act-fees/index'
import { Route as AuthFinanceChitActFeesNewRouteImport } from './routes/_auth/finance/chit-act-fees/new'
import { Route as AuthFinanceDecreesIndexRouteImport } from './routes/_auth/finance/decrees/index'
import { Route as AuthFinanceDecreesNewRouteImport } from './routes/_auth/finance/decrees/new'
import { Route as AuthFinanceGroupDepositsIndexRouteImport } from './routes/_auth/finance/group-deposits/index'
import { Route as AuthFinanceGroupDepositsNewRouteImport } from './routes/_auth/finance/group-deposits/new'
import { Route as AuthFinanceReceiptVouchersIndexRouteImport } from './routes/_auth/finance/receipt-vouchers/index'
import { Route as AuthFinanceReceiptVouchersNewRouteImport } from './routes/_auth/finance/receipt-vouchers/new'
import { Route as AuthFinanceWriteOffsIndexRouteImport } from './routes/_auth/finance/write-offs/index'
import { Route as AuthFinanceWriteOffsNewRouteImport } from './routes/_auth/finance/write-offs/new'
import { Route as AuthReportsFinancialBalanceSheetRouteImport } from './routes/_auth/reports/financial/balance-sheet'
import { Route as AuthReportsFinancialPnlRouteImport } from './routes/_auth/reports/financial/pnl'
import { Route as AuthReportsFinancialTrialBalanceRouteImport } from './routes/_auth/reports/financial/trial-balance'
import { Route as AuthReportsOperationalCollectionsRouteImport } from './routes/_auth/reports/operational/collections'
import { Route as AuthReportsOperationalStaffActivityRouteImport } from './routes/_auth/reports/operational/staff-activity'
import { Route as AuthSchemesIdIndexRouteImport } from './routes/_auth/schemes/$id/index'
import { Route as AuthSchemesIdCommissionRouteImport } from './routes/_auth/schemes/$id/commission'
import { Route as AuthSettingsAreasIndexRouteImport } from './routes/_auth/settings/areas/index'
import { Route as AuthSettingsAreasNewRouteImport } from './routes/_auth/settings/areas/new'
import { Route as AuthSettingsAreasNewGroupRouteImport } from './routes/_auth/settings/areas/new-group'
import { Route as AuthSettingsDevicesIndexRouteImport } from './routes/_auth/settings/devices/index'
import { Route as AuthSettingsDevicesNewRouteImport } from './routes/_auth/settings/devices/new'
import { Route as AuthSettingsFeeSlabsIndexRouteImport } from './routes/_auth/settings/fee-slabs/index'
import { Route as AuthSettingsFeeSlabsNewRouteImport } from './routes/_auth/settings/fee-slabs/new'
import { Route as AuthSettingsHolidaysIndexRouteImport } from './routes/_auth/settings/holidays/index'
import { Route as AuthSettingsHolidaysNewRouteImport } from './routes/_auth/settings/holidays/new'
import { Route as AuthSettingsNotificationsTemplatesRouteImport } from './routes/_auth/settings/notifications.templates'
import { Route as AuthSuretyIdIndexRouteImport } from './routes/_auth/surety/$id/index'
import { Route as AuthAuditResourceTypeIdRouteImport } from './routes/_auth/audit/resource.$type.$id'
import { Route as AuthFinancePaymentsIdStatusRouteImport } from './routes/_auth/finance/payments/$id/status'
import { Route as AuthFinanceWriteOffsIdRecoverRouteImport } from './routes/_auth/finance/write-offs/$id/recover'
import { Route as AuthSettingsDevicesIdDispatchRouteImport } from './routes/_auth/settings/devices/$id/dispatch'
import { Route as AuthSuretyIdNomineesNewRouteImport } from './routes/_auth/surety/$id/nominees/new'
import { Route as AuthSchemesIdCyclesNumAuctionRouteImport } from './routes/_auth/schemes/$id/cycles/$num/auction'
import { Route as AuthSchemesIdCyclesNumDuesRouteImport } from './routes/_auth/schemes/$id/cycles/$num/dues'

const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const ForcePasswordChangeRoute = ForcePasswordChangeRouteImport.update({
  id: '/force-password-change',
  path: '/force-password-change',
  getParentRoute: () => rootRouteImport,
} as any)
const MaintenanceRoute = MaintenanceRouteImport.update({
  id: '/maintenance',
  path: '/maintenance',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthIndexRoute = AuthIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthApprovalsRoute = AuthApprovalsRouteImport.update({
  id: '/approvals',
  path: '/approvals',
  getParentRoute: () => AuthRoute,
} as any)
const AuthInstructionsRoute = AuthInstructionsRouteImport.update({
  id: '/instructions',
  path: '/instructions',
  getParentRoute: () => AuthRoute,
} as any)
const AuthOperationsRoute = AuthOperationsRouteImport.update({
  id: '/operations',
  path: '/operations',
  getParentRoute: () => AuthRoute,
} as any)
const AuthPayoutsRoute = AuthPayoutsRouteImport.update({
  id: '/payouts',
  path: '/payouts',
  getParentRoute: () => AuthRoute,
} as any)
const PublicAppsRoute = PublicAppsRouteImport.update({
  id: '/_public/apps',
  path: '/apps',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicForgotPasswordRoute = PublicForgotPasswordRouteImport.update({
  id: '/_public/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicLoginRoute = PublicLoginRouteImport.update({
  id: '/_public/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicPrivacyRoute = PublicPrivacyRouteImport.update({
  id: '/_public/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicResetPasswordRoute = PublicResetPasswordRouteImport.update({
  id: '/_public/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicTermsRoute = PublicTermsRouteImport.update({
  id: '/_public/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthAccountingAccountsRoute = AuthAccountingAccountsRouteImport.update({
  id: '/accounting/accounts',
  path: '/accounting/accounts',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAccountingCommissionRoute =
  AuthAccountingCommissionRouteImport.update({
    id: '/accounting/commission',
    path: '/accounting/commission',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthAccountingPeriodsRoute = AuthAccountingPeriodsRouteImport.update({
  id: '/accounting/periods',
  path: '/accounting/periods',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAdminConfigRoute = AuthAdminConfigRouteImport.update({
  id: '/admin/config',
  path: '/admin/config',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAdminHealthRoute = AuthAdminHealthRouteImport.update({
  id: '/admin/health',
  path: '/admin/health',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAdminMaintenanceRoute = AuthAdminMaintenanceRouteImport.update({
  id: '/admin/maintenance',
  path: '/admin/maintenance',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAgentsIndexRoute = AuthAgentsIndexRouteImport.update({
  id: '/agents/',
  path: '/agents/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAgentsIdRoute = AuthAgentsIdRouteImport.update({
  id: '/agents/$id',
  path: '/agents/$id',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAgentsNewRoute = AuthAgentsNewRouteImport.update({
  id: '/agents/new',
  path: '/agents/new',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAuctionsIndexRoute = AuthAuctionsIndexRouteImport.update({
  id: '/auctions/',
  path: '/auctions/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAuditIndexRoute = AuthAuditIndexRouteImport.update({
  id: '/audit/',
  path: '/audit/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthComplianceSubscriberRegisterRoute =
  AuthComplianceSubscriberRegisterRouteImport.update({
    id: '/compliance/subscriber-register',
    path: '/compliance/subscriber-register',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthCrmIdRoute = AuthCrmIdRouteImport.update({
  id: '/crm/$id',
  path: '/crm/$id',
  getParentRoute: () => AuthRoute,
} as any)
const AuthCrmConvertedRoute = AuthCrmConvertedRouteImport.update({
  id: '/crm/converted',
  path: '/crm/converted',
  getParentRoute: () => AuthRoute,
} as any)
const AuthCrmLeadsRoute = AuthCrmLeadsRouteImport.update({
  id: '/crm/leads',
  path: '/crm/leads',
  getParentRoute: () => AuthRoute,
} as any)
const AuthCrmLostRoute = AuthCrmLostRouteImport.update({
  id: '/crm/lost',
  path: '/crm/lost',
  getParentRoute: () => AuthRoute,
} as any)
const AuthCrmNewRoute = AuthCrmNewRouteImport.update({
  id: '/crm/new',
  path: '/crm/new',
  getParentRoute: () => AuthRoute,
} as any)
const AuthCrmProspectsRoute = AuthCrmProspectsRouteImport.update({
  id: '/crm/prospects',
  path: '/crm/prospects',
  getParentRoute: () => AuthRoute,
} as any)
const AuthCustomersIndexRoute = AuthCustomersIndexRouteImport.update({
  id: '/customers/',
  path: '/customers/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthCustomersIdRoute = AuthCustomersIdRouteImport.update({
  id: '/customers/$id',
  path: '/customers/$id',
  getParentRoute: () => AuthRoute,
} as any)
const AuthCustomersNewRoute = AuthCustomersNewRouteImport.update({
  id: '/customers/new',
  path: '/customers/new',
  getParentRoute: () => AuthRoute,
} as any)
const AuthDefaultsIndexRoute = AuthDefaultsIndexRouteImport.update({
  id: '/defaults/',
  path: '/defaults/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthDefaultsIdRoute = AuthDefaultsIdRouteImport.update({
  id: '/defaults/$id',
  path: '/defaults/$id',
  getParentRoute: () => AuthRoute,
} as any)
const AuthFinanceCashVaultRoute = AuthFinanceCashVaultRouteImport.update({
  id: '/finance/cash-vault',
  path: '/finance/cash-vault',
  getParentRoute: () => AuthRoute,
} as any)
const AuthFinanceHandoversRoute = AuthFinanceHandoversRouteImport.update({
  id: '/finance/handovers',
  path: '/finance/handovers',
  getParentRoute: () => AuthRoute,
} as any)
const AuthFinanceReceiptsRoute = AuthFinanceReceiptsRouteImport.update({
  id: '/finance/receipts',
  path: '/finance/receipts',
  getParentRoute: () => AuthRoute,
} as any)
const AuthFinanceRunningReceiptsRoute =
  AuthFinanceRunningReceiptsRouteImport.update({
    id: '/finance/running-receipts',
    path: '/finance/running-receipts',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthForeclosureIndexRoute = AuthForeclosureIndexRouteImport.update({
  id: '/foreclosure/',
  path: '/foreclosure/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthLedgerAccountIdRoute = AuthLedgerAccountIdRouteImport.update({
  id: '/ledger/$accountId',
  path: '/ledger/$accountId',
  getParentRoute: () => AuthRoute,
} as any)
const AuthLogsAuthRoute = AuthLogsAuthRouteImport.update({
  id: '/logs/auth',
  path: '/logs/auth',
  getParentRoute: () => AuthRoute,
} as any)
const AuthLogsNotificationsRoute = AuthLogsNotificationsRouteImport.update({
  id: '/logs/notifications',
  path: '/logs/notifications',
  getParentRoute: () => AuthRoute,
} as any)
const AuthOverdueIndexRoute = AuthOverdueIndexRouteImport.update({
  id: '/overdue/',
  path: '/overdue/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthPidiSchemesIndexRoute = AuthPidiSchemesIndexRouteImport.update({
  id: '/pidi-schemes/',
  path: '/pidi-schemes/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthPidiSchemesIdRoute = AuthPidiSchemesIdRouteImport.update({
  id: '/pidi-schemes/$id',
  path: '/pidi-schemes/$id',
  getParentRoute: () => AuthRoute,
} as any)
const AuthPidiSchemesNewRoute = AuthPidiSchemesNewRouteImport.update({
  id: '/pidi-schemes/new',
  path: '/pidi-schemes/new',
  getParentRoute: () => AuthRoute,
} as any)
const AuthReconciliationImportIdRoute =
  AuthReconciliationImportIdRouteImport.update({
    id: '/reconciliation/$importId',
    path: '/reconciliation/$importId',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthReportsIndexRoute = AuthReportsIndexRouteImport.update({
  id: '/reports/',
  path: '/reports/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthReportsCodeRoute = AuthReportsCodeRouteImport.update({
  id: '/reports/$code',
  path: '/reports/$code',
  getParentRoute: () => AuthRoute,
} as any)
const AuthReportsArrearsRoute = AuthReportsArrearsRouteImport.update({
  id: '/reports/arrears',
  path: '/reports/arrears',
  getParentRoute: () => AuthRoute,
} as any)
const AuthReportsDaybookRoute = AuthReportsDaybookRouteImport.update({
  id: '/reports/daybook',
  path: '/reports/daybook',
  getParentRoute: () => AuthRoute,
} as any)
const AuthReportsSubscriberLedgerRoute =
  AuthReportsSubscriberLedgerRouteImport.update({
    id: '/reports/subscriber-ledger',
    path: '/reports/subscriber-ledger',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthSchemesIndexRoute = AuthSchemesIndexRouteImport.update({
  id: '/schemes/',
  path: '/schemes/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSchemesIdRoute = AuthSchemesIdRouteImport.update({
  id: '/schemes/$id',
  path: '/schemes/$id',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSchemesEstimateRoute = AuthSchemesEstimateRouteImport.update({
  id: '/schemes/estimate',
  path: '/schemes/estimate',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSchemesNewRoute = AuthSchemesNewRouteImport.update({
  id: '/schemes/new',
  path: '/schemes/new',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSchemesTransfersRoute = AuthSchemesTransfersRouteImport.update({
  id: '/schemes/transfers',
  path: '/schemes/transfers',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSettingsBranchesRoute = AuthSettingsBranchesRouteImport.update({
  id: '/settings/branches',
  path: '/settings/branches',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSettingsMpinRoute = AuthSettingsMpinRouteImport.update({
  id: '/settings/mpin',
  path: '/settings/mpin',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSettingsPasswordRoute = AuthSettingsPasswordRouteImport.update({
  id: '/settings/password',
  path: '/settings/password',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSettingsRolesRoute = AuthSettingsRolesRouteImport.update({
  id: '/settings/roles',
  path: '/settings/roles',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSettingsSecurityRoute = AuthSettingsSecurityRouteImport.update({
  id: '/settings/security',
  path: '/settings/security',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSettingsSessionsRoute = AuthSettingsSessionsRouteImport.update({
  id: '/settings/sessions',
  path: '/settings/sessions',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSetupCompanyRoute = AuthSetupCompanyRouteImport.update({
  id: '/setup/company',
  path: '/setup/company',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSuretyIndexRoute = AuthSuretyIndexRouteImport.update({
  id: '/surety/',
  path: '/surety/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthTaxIndexRoute = AuthTaxIndexRouteImport.update({
  id: '/tax/',
  path: '/tax/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthTemplatesIndexRoute = AuthTemplatesIndexRouteImport.update({
  id: '/templates/',
  path: '/templates/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthTemplatesIdRoute = AuthTemplatesIdRouteImport.update({
  id: '/templates/$id',
  path: '/templates/$id',
  getParentRoute: () => AuthRoute,
} as any)
const AuthTemplatesNewRoute = AuthTemplatesNewRouteImport.update({
  id: '/templates/new',
  path: '/templates/new',
  getParentRoute: () => AuthRoute,
} as any)
const AuthUsersIndexRoute = AuthUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthUsersIdRoute = AuthUsersIdRouteImport.update({
  id: '/users/$id',
  path: '/users/$id',
  getParentRoute: () => AuthRoute,
} as any)
const AuthUsersNewRoute = AuthUsersNewRouteImport.update({
  id: '/users/new',
  path: '/users/new',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAccountingGeneralTransactionsIndexRoute =
  AuthAccountingGeneralTransactionsIndexRouteImport.update({
    id: '/accounting/general-transactions/',
    path: '/accounting/general-transactions/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthAccountingGeneralTransactionsNewRoute =
  AuthAccountingGeneralTransactionsNewRouteImport.update({
    id: '/accounting/general-transactions/new',
    path: '/accounting/general-transactions/new',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthAccountingJournalIndexRoute =
  AuthAccountingJournalIndexRouteImport.update({
    id: '/accounting/journal/',
    path: '/accounting/journal/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthAdminProductsIndexRoute = AuthAdminProductsIndexRouteImport.update({
  id: '/admin/products/',
  path: '/admin/products/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAdminProductsNewRoute = AuthAdminProductsNewRouteImport.update({
  id: '/admin/products/new',
  path: '/admin/products/new',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAdminStaffIndexRoute = AuthAdminStaffIndexRouteImport.update({
  id: '/admin/staff/',
  path: '/admin/staff/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAdminStaffIdRoute = AuthAdminStaffIdRouteImport.update({
  id: '/admin/staff/$id',
  path: '/admin/staff/$id',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAdminStaffNewRoute = AuthAdminStaffNewRouteImport.update({
  id: '/admin/staff/new',
  path: '/admin/staff/new',
  getParentRoute: () => AuthRoute,
} as any)
const AuthFinanceAdvancesIndexRoute =
  AuthFinanceAdvancesIndexRouteImport.update({
    id: '/finance/advances/',
    path: '/finance/advances/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthFinanceAdvancesNewRoute = AuthFinanceAdvancesNewRouteImport.update({
  id: '/finance/advances/new',
  path: '/finance/advances/new',
  getParentRoute: () => AuthRoute,
} as any)
const AuthFinanceChequeRegisterIndexRoute =
  AuthFinanceChequeRegisterIndexRouteImport.update({
    id: '/finance/cheque-register/',
    path: '/finance/cheque-register/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthFinanceChequeRegisterNewRoute =
  AuthFinanceChequeRegisterNewRouteImport.update({
    id: '/finance/cheque-register/new',
    path: '/finance/cheque-register/new',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthFinanceChitActFeesIndexRoute =
  AuthFinanceChitActFeesIndexRouteImport.update({
    id: '/finance/chit-act-fees/',
    path: '/finance/chit-act-fees/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthFinanceChitActFeesNewRoute =
  AuthFinanceChitActFeesNewRouteImport.update({
    id: '/finance/chit-act-fees/new',
    path: '/finance/chit-act-fees/new',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthFinanceDecreesIndexRoute = AuthFinanceDecreesIndexRouteImport.update({
  id: '/finance/decrees/',
  path: '/finance/decrees/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthFinanceDecreesNewRoute = AuthFinanceDecreesNewRouteImport.update({
  id: '/finance/decrees/new',
  path: '/finance/decrees/new',
  getParentRoute: () => AuthRoute,
} as any)
const AuthFinanceGroupDepositsIndexRoute =
  AuthFinanceGroupDepositsIndexRouteImport.update({
    id: '/finance/group-deposits/',
    path: '/finance/group-deposits/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthFinanceGroupDepositsNewRoute =
  AuthFinanceGroupDepositsNewRouteImport.update({
    id: '/finance/group-deposits/new',
    path: '/finance/group-deposits/new',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthFinanceReceiptVouchersIndexRoute =
  AuthFinanceReceiptVouchersIndexRouteImport.update({
    id: '/finance/receipt-vouchers/',
    path: '/finance/receipt-vouchers/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthFinanceReceiptVouchersNewRoute =
  AuthFinanceReceiptVouchersNewRouteImport.update({
    id: '/finance/receipt-vouchers/new',
    path: '/finance/receipt-vouchers/new',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthFinanceWriteOffsIndexRoute =
  AuthFinanceWriteOffsIndexRouteImport.update({
    id: '/finance/write-offs/',
    path: '/finance/write-offs/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthFinanceWriteOffsNewRoute = AuthFinanceWriteOffsNewRouteImport.update({
  id: '/finance/write-offs/new',
  path: '/finance/write-offs/new',
  getParentRoute: () => AuthRoute,
} as any)
const AuthReportsFinancialBalanceSheetRoute =
  AuthReportsFinancialBalanceSheetRouteImport.update({
    id: '/reports/financial/balance-sheet',
    path: '/reports/financial/balance-sheet',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthReportsFinancialPnlRoute = AuthReportsFinancialPnlRouteImport.update({
  id: '/reports/financial/pnl',
  path: '/reports/financial/pnl',
  getParentRoute: () => AuthRoute,
} as any)
const AuthReportsFinancialTrialBalanceRoute =
  AuthReportsFinancialTrialBalanceRouteImport.update({
    id: '/reports/financial/trial-balance',
    path: '/reports/financial/trial-balance',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthReportsOperationalCollectionsRoute =
  AuthReportsOperationalCollectionsRouteImport.update({
    id: '/reports/operational/collections',
    path: '/reports/operational/collections',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthReportsOperationalStaffActivityRoute =
  AuthReportsOperationalStaffActivityRouteImport.update({
    id: '/reports/operational/staff-activity',
    path: '/reports/operational/staff-activity',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthSchemesIdIndexRoute = AuthSchemesIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthSchemesIdRoute,
} as any)
const AuthSchemesIdCommissionRoute = AuthSchemesIdCommissionRouteImport.update({
  id: '/commission',
  path: '/commission',
  getParentRoute: () => AuthSchemesIdRoute,
} as any)
const AuthSettingsAreasIndexRoute = AuthSettingsAreasIndexRouteImport.update({
  id: '/settings/areas/',
  path: '/settings/areas/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSettingsAreasNewRoute = AuthSettingsAreasNewRouteImport.update({
  id: '/settings/areas/new',
  path: '/settings/areas/new',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSettingsAreasNewGroupRoute =
  AuthSettingsAreasNewGroupRouteImport.update({
    id: '/settings/areas/new-group',
    path: '/settings/areas/new-group',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthSettingsDevicesIndexRoute =
  AuthSettingsDevicesIndexRouteImport.update({
    id: '/settings/devices/',
    path: '/settings/devices/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthSettingsDevicesNewRoute = AuthSettingsDevicesNewRouteImport.update({
  id: '/settings/devices/new',
  path: '/settings/devices/new',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSettingsFeeSlabsIndexRoute =
  AuthSettingsFeeSlabsIndexRouteImport.update({
    id: '/settings/fee-slabs/',
    path: '/settings/fee-slabs/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthSettingsFeeSlabsNewRoute = AuthSettingsFeeSlabsNewRouteImport.update({
  id: '/settings/fee-slabs/new',
  path: '/settings/fee-slabs/new',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSettingsHolidaysIndexRoute =
  AuthSettingsHolidaysIndexRouteImport.update({
    id: '/settings/holidays/',
    path: '/settings/holidays/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthSettingsHolidaysNewRoute = AuthSettingsHolidaysNewRouteImport.update({
  id: '/settings/holidays/new',
  path: '/settings/holidays/new',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSettingsNotificationsTemplatesRoute =
  AuthSettingsNotificationsTemplatesRouteImport.update({
    id: '/settings/notifications/templates',
    path: '/settings/notifications/templates',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthSuretyIdIndexRoute = AuthSuretyIdIndexRouteImport.update({
  id: '/surety/$id/',
  path: '/surety/$id/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAuditResourceTypeIdRoute = AuthAuditResourceTypeIdRouteImport.update({
  id: '/audit/resource/$type/$id',
  path: '/audit/resource/$type/$id',
  getParentRoute: () => AuthRoute,
} as any)
const AuthFinancePaymentsIdStatusRoute =
  AuthFinancePaymentsIdStatusRouteImport.update({
    id: '/finance/payments/$id/status',
    path: '/finance/payments/$id/status',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthFinanceWriteOffsIdRecoverRoute =
  AuthFinanceWriteOffsIdRecoverRouteImport.update({
    id: '/finance/write-offs/$id/recover',
    path: '/finance/write-offs/$id/recover',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthSettingsDevicesIdDispatchRoute =
  AuthSettingsDevicesIdDispatchRouteImport.update({
    id: '/settings/devices/$id/dispatch',
    path: '/settings/devices/$id/dispatch',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthSuretyIdNomineesNewRoute = AuthSuretyIdNomineesNewRouteImport.update({
  id: '/surety/$id/nominees/new',
  path: '/surety/$id/nominees/new',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSchemesIdCyclesNumAuctionRoute =
  AuthSchemesIdCyclesNumAuctionRouteImport.update({
    id: '/cycles/$num/auction',
    path: '/cycles/$num/auction',
    getParentRoute: () => AuthSchemesIdRoute,
  } as any)
const AuthSchemesIdCyclesNumDuesRoute =
  AuthSchemesIdCyclesNumDuesRouteImport.update({
    id: '/cycles/$num/dues',
    path: '/cycles/$num/dues',
    getParentRoute: () => AuthSchemesIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthIndexRoute
  '/force-password-change': typeof ForcePasswordChangeRoute
  '/maintenance': typeof MaintenanceRoute
  '/approvals': typeof AuthApprovalsRoute
  '/instructions': typeof AuthInstructionsRoute
  '/operations': typeof AuthOperationsRoute
  '/payouts': typeof AuthPayoutsRoute
  '/apps': typeof PublicAppsRoute
  '/forgot-password': typeof PublicForgotPasswordRoute
  '/login': typeof PublicLoginRoute
  '/privacy': typeof PublicPrivacyRoute
  '/reset-password': typeof PublicResetPasswordRoute
  '/terms': typeof PublicTermsRoute
  '/accounting/accounts': typeof AuthAccountingAccountsRoute
  '/accounting/commission': typeof AuthAccountingCommissionRoute
  '/accounting/periods': typeof AuthAccountingPeriodsRoute
  '/admin/config': typeof AuthAdminConfigRoute
  '/admin/health': typeof AuthAdminHealthRoute
  '/admin/maintenance': typeof AuthAdminMaintenanceRoute
  '/agents/$id': typeof AuthAgentsIdRoute
  '/agents/new': typeof AuthAgentsNewRoute
  '/compliance/subscriber-register': typeof AuthComplianceSubscriberRegisterRoute
  '/crm/$id': typeof AuthCrmIdRoute
  '/crm/converted': typeof AuthCrmConvertedRoute
  '/crm/leads': typeof AuthCrmLeadsRoute
  '/crm/lost': typeof AuthCrmLostRoute
  '/crm/new': typeof AuthCrmNewRoute
  '/crm/prospects': typeof AuthCrmProspectsRoute
  '/customers/$id': typeof AuthCustomersIdRoute
  '/customers/new': typeof AuthCustomersNewRoute
  '/defaults/$id': typeof AuthDefaultsIdRoute
  '/finance/cash-vault': typeof AuthFinanceCashVaultRoute
  '/finance/handovers': typeof AuthFinanceHandoversRoute
  '/finance/receipts': typeof AuthFinanceReceiptsRoute
  '/finance/running-receipts': typeof AuthFinanceRunningReceiptsRoute
  '/ledger/$accountId': typeof AuthLedgerAccountIdRoute
  '/logs/auth': typeof AuthLogsAuthRoute
  '/logs/notifications': typeof AuthLogsNotificationsRoute
  '/pidi-schemes/$id': typeof AuthPidiSchemesIdRoute
  '/pidi-schemes/new': typeof AuthPidiSchemesNewRoute
  '/reconciliation/$importId': typeof AuthReconciliationImportIdRoute
  '/reports/$code': typeof AuthReportsCodeRoute
  '/reports/arrears': typeof AuthReportsArrearsRoute
  '/reports/daybook': typeof AuthReportsDaybookRoute
  '/reports/subscriber-ledger': typeof AuthReportsSubscriberLedgerRoute
  '/schemes/$id': typeof AuthSchemesIdRouteWithChildren
  '/schemes/estimate': typeof AuthSchemesEstimateRoute
  '/schemes/new': typeof AuthSchemesNewRoute
  '/schemes/transfers': typeof AuthSchemesTransfersRoute
  '/settings/branches': typeof AuthSettingsBranchesRoute
  '/settings/mpin': typeof AuthSettingsMpinRoute
  '/settings/password': typeof AuthSettingsPasswordRoute
  '/settings/roles': typeof AuthSettingsRolesRoute
  '/settings/security': typeof AuthSettingsSecurityRoute
  '/settings/sessions': typeof AuthSettingsSessionsRoute
  '/setup/company': typeof AuthSetupCompanyRoute
  '/templates/$id': typeof AuthTemplatesIdRoute
  '/templates/new': typeof AuthTemplatesNewRoute
  '/users/$id': typeof AuthUsersIdRoute
  '/users/new': typeof AuthUsersNewRoute
  '/agents/': typeof AuthAgentsIndexRoute
  '/auctions/': typeof AuthAuctionsIndexRoute
  '/audit/': typeof AuthAuditIndexRoute
  '/customers/': typeof AuthCustomersIndexRoute
  '/defaults/': typeof AuthDefaultsIndexRoute
  '/foreclosure/': typeof AuthForeclosureIndexRoute
  '/overdue/': typeof AuthOverdueIndexRoute
  '/pidi-schemes/': typeof AuthPidiSchemesIndexRoute
  '/reports/': typeof AuthReportsIndexRoute
  '/schemes/': typeof AuthSchemesIndexRoute
  '/surety/': typeof AuthSuretyIndexRoute
  '/tax/': typeof AuthTaxIndexRoute
  '/templates/': typeof AuthTemplatesIndexRoute
  '/users/': typeof AuthUsersIndexRoute
  '/accounting/general-transactions/new': typeof AuthAccountingGeneralTransactionsNewRoute
  '/admin/products/new': typeof AuthAdminProductsNewRoute
  '/admin/staff/$id': typeof AuthAdminStaffIdRoute
  '/admin/staff/new': typeof AuthAdminStaffNewRoute
  '/finance/advances/new': typeof AuthFinanceAdvancesNewRoute
  '/finance/cheque-register/new': typeof AuthFinanceChequeRegisterNewRoute
  '/finance/chit-act-fees/new': typeof AuthFinanceChitActFeesNewRoute
  '/finance/decrees/new': typeof AuthFinanceDecreesNewRoute
  '/finance/group-deposits/new': typeof AuthFinanceGroupDepositsNewRoute
  '/finance/receipt-vouchers/new': typeof AuthFinanceReceiptVouchersNewRoute
  '/finance/write-offs/new': typeof AuthFinanceWriteOffsNewRoute
  '/reports/financial/balance-sheet': typeof AuthReportsFinancialBalanceSheetRoute
  '/reports/financial/pnl': typeof AuthReportsFinancialPnlRoute
  '/reports/financial/trial-balance': typeof AuthReportsFinancialTrialBalanceRoute
  '/reports/operational/collections': typeof AuthReportsOperationalCollectionsRoute
  '/reports/operational/staff-activity': typeof AuthReportsOperationalStaffActivityRoute
  '/schemes/$id/commission': typeof AuthSchemesIdCommissionRoute
  '/settings/areas/new': typeof AuthSettingsAreasNewRoute
  '/settings/areas/new-group': typeof AuthSettingsAreasNewGroupRoute
  '/settings/devices/new': typeof AuthSettingsDevicesNewRoute
  '/settings/fee-slabs/new': typeof AuthSettingsFeeSlabsNewRoute
  '/settings/holidays/new': typeof AuthSettingsHolidaysNewRoute
  '/settings/notifications/templates': typeof AuthSettingsNotificationsTemplatesRoute
  '/accounting/general-transactions/': typeof AuthAccountingGeneralTransactionsIndexRoute
  '/accounting/journal/': typeof AuthAccountingJournalIndexRoute
  '/admin/products/': typeof AuthAdminProductsIndexRoute
  '/admin/staff/': typeof AuthAdminStaffIndexRoute
  '/finance/advances/': typeof AuthFinanceAdvancesIndexRoute
  '/finance/cheque-register/': typeof AuthFinanceChequeRegisterIndexRoute
  '/finance/chit-act-fees/': typeof AuthFinanceChitActFeesIndexRoute
  '/finance/decrees/': typeof AuthFinanceDecreesIndexRoute
  '/finance/group-deposits/': typeof AuthFinanceGroupDepositsIndexRoute
  '/finance/receipt-vouchers/': typeof AuthFinanceReceiptVouchersIndexRoute
  '/finance/write-offs/': typeof AuthFinanceWriteOffsIndexRoute
  '/schemes/$id/': typeof AuthSchemesIdIndexRoute
  '/settings/areas/': typeof AuthSettingsAreasIndexRoute
  '/settings/devices/': typeof AuthSettingsDevicesIndexRoute
  '/settings/fee-slabs/': typeof AuthSettingsFeeSlabsIndexRoute
  '/settings/holidays/': typeof AuthSettingsHolidaysIndexRoute
  '/surety/$id/': typeof AuthSuretyIdIndexRoute
  '/audit/resource/$type/$id': typeof AuthAuditResourceTypeIdRoute
  '/finance/payments/$id/status': typeof AuthFinancePaymentsIdStatusRoute
  '/finance/write-offs/$id/recover': typeof AuthFinanceWriteOffsIdRecoverRoute
  '/settings/devices/$id/dispatch': typeof AuthSettingsDevicesIdDispatchRoute
  '/surety/$id/nominees/new': typeof AuthSuretyIdNomineesNewRoute
  '/schemes/$id/cycles/$num/auction': typeof AuthSchemesIdCyclesNumAuctionRoute
  '/schemes/$id/cycles/$num/dues': typeof AuthSchemesIdCyclesNumDuesRoute
}
export interface FileRoutesByTo {
  '/force-password-change': typeof ForcePasswordChangeRoute
  '/maintenance': typeof MaintenanceRoute
  '/approvals': typeof AuthApprovalsRoute
  '/instructions': typeof AuthInstructionsRoute
  '/operations': typeof AuthOperationsRoute
  '/payouts': typeof AuthPayoutsRoute
  '/apps': typeof PublicAppsRoute
  '/forgot-password': typeof PublicForgotPasswordRoute
  '/login': typeof PublicLoginRoute
  '/privacy': typeof PublicPrivacyRoute
  '/reset-password': typeof PublicResetPasswordRoute
  '/terms': typeof PublicTermsRoute
  '/': typeof AuthIndexRoute
  '/accounting/accounts': typeof AuthAccountingAccountsRoute
  '/accounting/commission': typeof AuthAccountingCommissionRoute
  '/accounting/periods': typeof AuthAccountingPeriodsRoute
  '/admin/config': typeof AuthAdminConfigRoute
  '/admin/health': typeof AuthAdminHealthRoute
  '/admin/maintenance': typeof AuthAdminMaintenanceRoute
  '/agents/$id': typeof AuthAgentsIdRoute
  '/agents/new': typeof AuthAgentsNewRoute
  '/compliance/subscriber-register': typeof AuthComplianceSubscriberRegisterRoute
  '/crm/$id': typeof AuthCrmIdRoute
  '/crm/converted': typeof AuthCrmConvertedRoute
  '/crm/leads': typeof AuthCrmLeadsRoute
  '/crm/lost': typeof AuthCrmLostRoute
  '/crm/new': typeof AuthCrmNewRoute
  '/crm/prospects': typeof AuthCrmProspectsRoute
  '/customers/$id': typeof AuthCustomersIdRoute
  '/customers/new': typeof AuthCustomersNewRoute
  '/defaults/$id': typeof AuthDefaultsIdRoute
  '/finance/cash-vault': typeof AuthFinanceCashVaultRoute
  '/finance/handovers': typeof AuthFinanceHandoversRoute
  '/finance/receipts': typeof AuthFinanceReceiptsRoute
  '/finance/running-receipts': typeof AuthFinanceRunningReceiptsRoute
  '/ledger/$accountId': typeof AuthLedgerAccountIdRoute
  '/logs/auth': typeof AuthLogsAuthRoute
  '/logs/notifications': typeof AuthLogsNotificationsRoute
  '/pidi-schemes/$id': typeof AuthPidiSchemesIdRoute
  '/pidi-schemes/new': typeof AuthPidiSchemesNewRoute
  '/reconciliation/$importId': typeof AuthReconciliationImportIdRoute
  '/reports/$code': typeof AuthReportsCodeRoute
  '/reports/arrears': typeof AuthReportsArrearsRoute
  '/reports/daybook': typeof AuthReportsDaybookRoute
  '/reports/subscriber-ledger': typeof AuthReportsSubscriberLedgerRoute
  '/schemes/estimate': typeof AuthSchemesEstimateRoute
  '/schemes/new': typeof AuthSchemesNewRoute
  '/schemes/transfers': typeof AuthSchemesTransfersRoute
  '/settings/branches': typeof AuthSettingsBranchesRoute
  '/settings/mpin': typeof AuthSettingsMpinRoute
  '/settings/password': typeof AuthSettingsPasswordRoute
  '/settings/roles': typeof AuthSettingsRolesRoute
  '/settings/security': typeof AuthSettingsSecurityRoute
  '/settings/sessions': typeof AuthSettingsSessionsRoute
  '/setup/company': typeof AuthSetupCompanyRoute
  '/templates/$id': typeof AuthTemplatesIdRoute
  '/templates/new': typeof AuthTemplatesNewRoute
  '/users/$id': typeof AuthUsersIdRoute
  '/users/new': typeof AuthUsersNewRoute
  '/agents': typeof AuthAgentsIndexRoute
  '/auctions': typeof AuthAuctionsIndexRoute
  '/audit': typeof AuthAuditIndexRoute
  '/customers': typeof AuthCustomersIndexRoute
  '/defaults': typeof AuthDefaultsIndexRoute
  '/foreclosure': typeof AuthForeclosureIndexRoute
  '/overdue': typeof AuthOverdueIndexRoute
  '/pidi-schemes': typeof AuthPidiSchemesIndexRoute
  '/reports': typeof AuthReportsIndexRoute
  '/schemes': typeof AuthSchemesIndexRoute
  '/surety': typeof AuthSuretyIndexRoute
  '/tax': typeof AuthTaxIndexRoute
  '/templates': typeof AuthTemplatesIndexRoute
  '/users': typeof AuthUsersIndexRoute
  '/accounting/general-transactions/new': typeof AuthAccountingGeneralTransactionsNewRoute
  '/admin/products/new': typeof AuthAdminProductsNewRoute
  '/admin/staff/$id': typeof AuthAdminStaffIdRoute
  '/admin/staff/new': typeof AuthAdminStaffNewRoute
  '/finance/advances/new': typeof AuthFinanceAdvancesNewRoute
  '/finance/cheque-register/new': typeof AuthFinanceChequeRegisterNewRoute
  '/finance/chit-act-fees/new': typeof AuthFinanceChitActFeesNewRoute
  '/finance/decrees/new': typeof AuthFinanceDecreesNewRoute
  '/finance/group-deposits/new': typeof AuthFinanceGroupDepositsNewRoute
  '/finance/receipt-vouchers/new': typeof AuthFinanceReceiptVouchersNewRoute
  '/finance/write-offs/new': typeof AuthFinanceWriteOffsNewRoute
  '/reports/financial/balance-sheet': typeof AuthReportsFinancialBalanceSheetRoute
  '/reports/financial/pnl': typeof AuthReportsFinancialPnlRoute
  '/reports/financial/trial-balance': typeof AuthReportsFinancialTrialBalanceRoute
  '/reports/operational/collections': typeof AuthReportsOperationalCollectionsRoute
  '/reports/operational/staff-activity': typeof AuthReportsOperationalStaffActivityRoute
  '/schemes/$id/commission': typeof AuthSchemesIdCommissionRoute
  '/settings/areas/new': typeof AuthSettingsAreasNewRoute
  '/settings/areas/new-group': typeof AuthSettingsAreasNewGroupRoute
  '/settings/devices/new': typeof AuthSettingsDevicesNewRoute
  '/settings/fee-slabs/new': typeof AuthSettingsFeeSlabsNewRoute
  '/settings/holidays/new': typeof AuthSettingsHolidaysNewRoute
  '/settings/notifications/templates': typeof AuthSettingsNotificationsTemplatesRoute
  '/accounting/general-transactions': typeof AuthAccountingGeneralTransactionsIndexRoute
  '/accounting/journal': typeof AuthAccountingJournalIndexRoute
  '/admin/products': typeof AuthAdminProductsIndexRoute
  '/admin/staff': typeof AuthAdminStaffIndexRoute
  '/finance/advances': typeof AuthFinanceAdvancesIndexRoute
  '/finance/cheque-register': typeof AuthFinanceChequeRegisterIndexRoute
  '/finance/chit-act-fees': typeof AuthFinanceChitActFeesIndexRoute
  '/finance/decrees': typeof AuthFinanceDecreesIndexRoute
  '/finance/group-deposits': typeof AuthFinanceGroupDepositsIndexRoute
  '/finance/receipt-vouchers': typeof AuthFinanceReceiptVouchersIndexRoute
  '/finance/write-offs': typeof AuthFinanceWriteOffsIndexRoute
  '/schemes/$id': typeof AuthSchemesIdIndexRoute
  '/settings/areas': typeof AuthSettingsAreasIndexRoute
  '/settings/devices': typeof AuthSettingsDevicesIndexRoute
  '/settings/fee-slabs': typeof AuthSettingsFeeSlabsIndexRoute
  '/settings/holidays': typeof AuthSettingsHolidaysIndexRoute
  '/surety/$id': typeof AuthSuretyIdIndexRoute
  '/audit/resource/$type/$id': typeof AuthAuditResourceTypeIdRoute
  '/finance/payments/$id/status': typeof AuthFinancePaymentsIdStatusRoute
  '/finance/write-offs/$id/recover': typeof AuthFinanceWriteOffsIdRecoverRoute
  '/settings/devices/$id/dispatch': typeof AuthSettingsDevicesIdDispatchRoute
  '/surety/$id/nominees/new': typeof AuthSuretyIdNomineesNewRoute
  '/schemes/$id/cycles/$num/auction': typeof AuthSchemesIdCyclesNumAuctionRoute
  '/schemes/$id/cycles/$num/dues': typeof AuthSchemesIdCyclesNumDuesRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_auth': typeof AuthRouteWithChildren
  '/force-password-change': typeof ForcePasswordChangeRoute
  '/maintenance': typeof MaintenanceRoute
  '/_auth/approvals': typeof AuthApprovalsRoute
  '/_auth/instructions': typeof AuthInstructionsRoute
  '/_auth/operations': typeof AuthOperationsRoute
  '/_auth/payouts': typeof AuthPayoutsRoute
  '/_public/apps': typeof PublicAppsRoute
  '/_public/forgot-password': typeof PublicForgotPasswordRoute
  '/_public/login': typeof PublicLoginRoute
  '/_public/privacy': typeof PublicPrivacyRoute
  '/_public/reset-password': typeof PublicResetPasswordRoute
  '/_public/terms': typeof PublicTermsRoute
  '/_auth/': typeof AuthIndexRoute
  '/_auth/accounting/accounts': typeof AuthAccountingAccountsRoute
  '/_auth/accounting/commission': typeof AuthAccountingCommissionRoute
  '/_auth/accounting/periods': typeof AuthAccountingPeriodsRoute
  '/_auth/admin/config': typeof AuthAdminConfigRoute
  '/_auth/admin/health': typeof AuthAdminHealthRoute
  '/_auth/admin/maintenance': typeof AuthAdminMaintenanceRoute
  '/_auth/agents/$id': typeof AuthAgentsIdRoute
  '/_auth/agents/new': typeof AuthAgentsNewRoute
  '/_auth/compliance/subscriber-register': typeof AuthComplianceSubscriberRegisterRoute
  '/_auth/crm/$id': typeof AuthCrmIdRoute
  '/_auth/crm/converted': typeof AuthCrmConvertedRoute
  '/_auth/crm/leads': typeof AuthCrmLeadsRoute
  '/_auth/crm/lost': typeof AuthCrmLostRoute
  '/_auth/crm/new': typeof AuthCrmNewRoute
  '/_auth/crm/prospects': typeof AuthCrmProspectsRoute
  '/_auth/customers/$id': typeof AuthCustomersIdRoute
  '/_auth/customers/new': typeof AuthCustomersNewRoute
  '/_auth/defaults/$id': typeof AuthDefaultsIdRoute
  '/_auth/finance/cash-vault': typeof AuthFinanceCashVaultRoute
  '/_auth/finance/handovers': typeof AuthFinanceHandoversRoute
  '/_auth/finance/receipts': typeof AuthFinanceReceiptsRoute
  '/_auth/finance/running-receipts': typeof AuthFinanceRunningReceiptsRoute
  '/_auth/ledger/$accountId': typeof AuthLedgerAccountIdRoute
  '/_auth/logs/auth': typeof AuthLogsAuthRoute
  '/_auth/logs/notifications': typeof AuthLogsNotificationsRoute
  '/_auth/pidi-schemes/$id': typeof AuthPidiSchemesIdRoute
  '/_auth/pidi-schemes/new': typeof AuthPidiSchemesNewRoute
  '/_auth/reconciliation/$importId': typeof AuthReconciliationImportIdRoute
  '/_auth/reports/$code': typeof AuthReportsCodeRoute
  '/_auth/reports/arrears': typeof AuthReportsArrearsRoute
  '/_auth/reports/daybook': typeof AuthReportsDaybookRoute
  '/_auth/reports/subscriber-ledger': typeof AuthReportsSubscriberLedgerRoute
  '/_auth/schemes/$id': typeof AuthSchemesIdRouteWithChildren
  '/_auth/schemes/estimate': typeof AuthSchemesEstimateRoute
  '/_auth/schemes/new': typeof AuthSchemesNewRoute
  '/_auth/schemes/transfers': typeof AuthSchemesTransfersRoute
  '/_auth/settings/branches': typeof AuthSettingsBranchesRoute
  '/_auth/settings/mpin': typeof AuthSettingsMpinRoute
  '/_auth/settings/password': typeof AuthSettingsPasswordRoute
  '/_auth/settings/roles': typeof AuthSettingsRolesRoute
  '/_auth/settings/security': typeof AuthSettingsSecurityRoute
  '/_auth/settings/sessions': typeof AuthSettingsSessionsRoute
  '/_auth/setup/company': typeof AuthSetupCompanyRoute
  '/_auth/templates/$id': typeof AuthTemplatesIdRoute
  '/_auth/templates/new': typeof AuthTemplatesNewRoute
  '/_auth/users/$id': typeof AuthUsersIdRoute
  '/_auth/users/new': typeof AuthUsersNewRoute
  '/_auth/agents/': typeof AuthAgentsIndexRoute
  '/_auth/auctions/': typeof AuthAuctionsIndexRoute
  '/_auth/audit/': typeof AuthAuditIndexRoute
  '/_auth/customers/': typeof AuthCustomersIndexRoute
  '/_auth/defaults/': typeof AuthDefaultsIndexRoute
  '/_auth/foreclosure/': typeof AuthForeclosureIndexRoute
  '/_auth/overdue/': typeof AuthOverdueIndexRoute
  '/_auth/pidi-schemes/': typeof AuthPidiSchemesIndexRoute
  '/_auth/reports/': typeof AuthReportsIndexRoute
  '/_auth/schemes/': typeof AuthSchemesIndexRoute
  '/_auth/surety/': typeof AuthSuretyIndexRoute
  '/_auth/tax/': typeof AuthTaxIndexRoute
  '/_auth/templates/': typeof AuthTemplatesIndexRoute
  '/_auth/users/': typeof AuthUsersIndexRoute
  '/_auth/accounting/general-transactions/new': typeof AuthAccountingGeneralTransactionsNewRoute
  '/_auth/admin/products/new': typeof AuthAdminProductsNewRoute
  '/_auth/admin/staff/$id': typeof AuthAdminStaffIdRoute
  '/_auth/admin/staff/new': typeof AuthAdminStaffNewRoute
  '/_auth/finance/advances/new': typeof AuthFinanceAdvancesNewRoute
  '/_auth/finance/cheque-register/new': typeof AuthFinanceChequeRegisterNewRoute
  '/_auth/finance/chit-act-fees/new': typeof AuthFinanceChitActFeesNewRoute
  '/_auth/finance/decrees/new': typeof AuthFinanceDecreesNewRoute
  '/_auth/finance/group-deposits/new': typeof AuthFinanceGroupDepositsNewRoute
  '/_auth/finance/receipt-vouchers/new': typeof AuthFinanceReceiptVouchersNewRoute
  '/_auth/finance/write-offs/new': typeof AuthFinanceWriteOffsNewRoute
  '/_auth/reports/financial/balance-sheet': typeof AuthReportsFinancialBalanceSheetRoute
  '/_auth/reports/financial/pnl': typeof AuthReportsFinancialPnlRoute
  '/_auth/reports/financial/trial-balance': typeof AuthReportsFinancialTrialBalanceRoute
  '/_auth/reports/operational/collections': typeof AuthReportsOperationalCollectionsRoute
  '/_auth/reports/operational/staff-activity': typeof AuthReportsOperationalStaffActivityRoute
  '/_auth/schemes/$id/commission': typeof AuthSchemesIdCommissionRoute
  '/_auth/settings/areas/new': typeof AuthSettingsAreasNewRoute
  '/_auth/settings/areas/new-group': typeof AuthSettingsAreasNewGroupRoute
  '/_auth/settings/devices/new': typeof AuthSettingsDevicesNewRoute
  '/_auth/settings/fee-slabs/new': typeof AuthSettingsFeeSlabsNewRoute
  '/_auth/settings/holidays/new': typeof AuthSettingsHolidaysNewRoute
  '/_auth/settings/notifications/templates': typeof AuthSettingsNotificationsTemplatesRoute
  '/_auth/accounting/general-transactions/': typeof AuthAccountingGeneralTransactionsIndexRoute
  '/_auth/accounting/journal/': typeof AuthAccountingJournalIndexRoute
  '/_auth/admin/products/': typeof AuthAdminProductsIndexRoute
  '/_auth/admin/staff/': typeof AuthAdminStaffIndexRoute
  '/_auth/finance/advances/': typeof AuthFinanceAdvancesIndexRoute
  '/_auth/finance/cheque-register/': typeof AuthFinanceChequeRegisterIndexRoute
  '/_auth/finance/chit-act-fees/': typeof AuthFinanceChitActFeesIndexRoute
  '/_auth/finance/decrees/': typeof AuthFinanceDecreesIndexRoute
  '/_auth/finance/group-deposits/': typeof AuthFinanceGroupDepositsIndexRoute
  '/_auth/finance/receipt-vouchers/': typeof AuthFinanceReceiptVouchersIndexRoute
  '/_auth/finance/write-offs/': typeof AuthFinanceWriteOffsIndexRoute
  '/_auth/schemes/$id/': typeof AuthSchemesIdIndexRoute
  '/_auth/settings/areas/': typeof AuthSettingsAreasIndexRoute
  '/_auth/settings/devices/': typeof AuthSettingsDevicesIndexRoute
  '/_auth/settings/fee-slabs/': typeof AuthSettingsFeeSlabsIndexRoute
  '/_auth/settings/holidays/': typeof AuthSettingsHolidaysIndexRoute
  '/_auth/surety/$id/': typeof AuthSuretyIdIndexRoute
  '/_auth/audit/resource/$type/$id': typeof AuthAuditResourceTypeIdRoute
  '/_auth/finance/payments/$id/status': typeof AuthFinancePaymentsIdStatusRoute
  '/_auth/finance/write-offs/$id/recover': typeof AuthFinanceWriteOffsIdRecoverRoute
  '/_auth/settings/devices/$id/dispatch': typeof AuthSettingsDevicesIdDispatchRoute
  '/_auth/surety/$id/nominees/new': typeof AuthSuretyIdNomineesNewRoute
  '/_auth/schemes/$id/cycles/$num/auction': typeof AuthSchemesIdCyclesNumAuctionRoute
  '/_auth/schemes/$id/cycles/$num/dues': typeof AuthSchemesIdCyclesNumDuesRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/force-password-change'
    | '/maintenance'
    | '/approvals'
    | '/instructions'
    | '/operations'
    | '/payouts'
    | '/apps'
    | '/forgot-password'
    | '/login'
    | '/privacy'
    | '/reset-password'
    | '/terms'
    | '/accounting/accounts'
    | '/accounting/commission'
    | '/accounting/periods'
    | '/admin/config'
    | '/admin/health'
    | '/admin/maintenance'
    | '/agents/$id'
    | '/agents/new'
    | '/compliance/subscriber-register'
    | '/crm/$id'
    | '/crm/converted'
    | '/crm/leads'
    | '/crm/lost'
    | '/crm/new'
    | '/crm/prospects'
    | '/customers/$id'
    | '/customers/new'
    | '/defaults/$id'
    | '/finance/cash-vault'
    | '/finance/handovers'
    | '/finance/receipts'
    | '/finance/running-receipts'
    | '/ledger/$accountId'
    | '/logs/auth'
    | '/logs/notifications'
    | '/pidi-schemes/$id'
    | '/pidi-schemes/new'
    | '/reconciliation/$importId'
    | '/reports/$code'
    | '/reports/arrears'
    | '/reports/daybook'
    | '/reports/subscriber-ledger'
    | '/schemes/$id'
    | '/schemes/estimate'
    | '/schemes/new'
    | '/schemes/transfers'
    | '/settings/branches'
    | '/settings/mpin'
    | '/settings/password'
    | '/settings/roles'
    | '/settings/security'
    | '/settings/sessions'
    | '/setup/company'
    | '/templates/$id'
    | '/templates/new'
    | '/users/$id'
    | '/users/new'
    | '/agents/'
    | '/auctions/'
    | '/audit/'
    | '/customers/'
    | '/defaults/'
    | '/foreclosure/'
    | '/overdue/'
    | '/pidi-schemes/'
    | '/reports/'
    | '/schemes/'
    | '/surety/'
    | '/tax/'
    | '/templates/'
    | '/users/'
    | '/accounting/general-transactions/new'
    | '/admin/products/new'
    | '/admin/staff/$id'
    | '/admin/staff/new'
    | '/finance/advances/new'
    | '/finance/cheque-register/new'
    | '/finance/chit-act-fees/new'
    | '/finance/decrees/new'
    | '/finance/group-deposits/new'
    | '/finance/receipt-vouchers/new'
    | '/finance/write-offs/new'
    | '/reports/financial/balance-sheet'
    | '/reports/financial/pnl'
    | '/reports/financial/trial-balance'
    | '/reports/operational/collections'
    | '/reports/operational/staff-activity'
    | '/schemes/$id/commission'
    | '/settings/areas/new'
    | '/settings/areas/new-group'
    | '/settings/devices/new'
    | '/settings/fee-slabs/new'
    | '/settings/holidays/new'
    | '/settings/notifications/templates'
    | '/accounting/general-transactions/'
    | '/accounting/journal/'
    | '/admin/products/'
    | '/admin/staff/'
    | '/finance/advances/'
    | '/finance/cheque-register/'
    | '/finance/chit-act-fees/'
    | '/finance/decrees/'
    | '/finance/group-deposits/'
    | '/finance/receipt-vouchers/'
    | '/finance/write-offs/'
    | '/schemes/$id/'
    | '/settings/areas/'
    | '/settings/devices/'
    | '/settings/fee-slabs/'
    | '/settings/holidays/'
    | '/surety/$id/'
    | '/audit/resource/$type/$id'
    | '/finance/payments/$id/status'
    | '/finance/write-offs/$id/recover'
    | '/settings/devices/$id/dispatch'
    | '/surety/$id/nominees/new'
    | '/schemes/$id/cycles/$num/auction'
    | '/schemes/$id/cycles/$num/dues'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/force-password-change'
    | '/maintenance'
    | '/approvals'
    | '/instructions'
    | '/operations'
    | '/payouts'
    | '/apps'
    | '/forgot-password'
    | '/login'
    | '/privacy'
    | '/reset-password'
    | '/terms'
    | '/'
    | '/accounting/accounts'
    | '/accounting/commission'
    | '/accounting/periods'
    | '/admin/config'
    | '/admin/health'
    | '/admin/maintenance'
    | '/agents/$id'
    | '/agents/new'
    | '/compliance/subscriber-register'
    | '/crm/$id'
    | '/crm/converted'
    | '/crm/leads'
    | '/crm/lost'
    | '/crm/new'
    | '/crm/prospects'
    | '/customers/$id'
    | '/customers/new'
    | '/defaults/$id'
    | '/finance/cash-vault'
    | '/finance/handovers'
    | '/finance/receipts'
    | '/finance/running-receipts'
    | '/ledger/$accountId'
    | '/logs/auth'
    | '/logs/notifications'
    | '/pidi-schemes/$id'
    | '/pidi-schemes/new'
    | '/reconciliation/$importId'
    | '/reports/$code'
    | '/reports/arrears'
    | '/reports/daybook'
    | '/reports/subscriber-ledger'
    | '/schemes/estimate'
    | '/schemes/new'
    | '/schemes/transfers'
    | '/settings/branches'
    | '/settings/mpin'
    | '/settings/password'
    | '/settings/roles'
    | '/settings/security'
    | '/settings/sessions'
    | '/setup/company'
    | '/templates/$id'
    | '/templates/new'
    | '/users/$id'
    | '/users/new'
    | '/agents'
    | '/auctions'
    | '/audit'
    | '/customers'
    | '/defaults'
    | '/foreclosure'
    | '/overdue'
    | '/pidi-schemes'
    | '/reports'
    | '/schemes'
    | '/surety'
    | '/tax'
    | '/templates'
    | '/users'
    | '/accounting/general-transactions/new'
    | '/admin/products/new'
    | '/admin/staff/$id'
    | '/admin/staff/new'
    | '/finance/advances/new'
    | '/finance/cheque-register/new'
    | '/finance/chit-act-fees/new'
    | '/finance/decrees/new'
    | '/finance/group-deposits/new'
    | '/finance/receipt-vouchers/new'
    | '/finance/write-offs/new'
    | '/reports/financial/balance-sheet'
    | '/reports/financial/pnl'
    | '/reports/financial/trial-balance'
    | '/reports/operational/collections'
    | '/reports/operational/staff-activity'
    | '/schemes/$id/commission'
    | '/settings/areas/new'
    | '/settings/areas/new-group'
    | '/settings/devices/new'
    | '/settings/fee-slabs/new'
    | '/settings/holidays/new'
    | '/settings/notifications/templates'
    | '/accounting/general-transactions'
    | '/accounting/journal'
    | '/admin/products'
    | '/admin/staff'
    | '/finance/advances'
    | '/finance/cheque-register'
    | '/finance/chit-act-fees'
    | '/finance/decrees'
    | '/finance/group-deposits'
    | '/finance/receipt-vouchers'
    | '/finance/write-offs'
    | '/schemes/$id'
    | '/settings/areas'
    | '/settings/devices'
    | '/settings/fee-slabs'
    | '/settings/holidays'
    | '/surety/$id'
    | '/audit/resource/$type/$id'
    | '/finance/payments/$id/status'
    | '/finance/write-offs/$id/recover'
    | '/settings/devices/$id/dispatch'
    | '/surety/$id/nominees/new'
    | '/schemes/$id/cycles/$num/auction'
    | '/schemes/$id/cycles/$num/dues'
  id:
    | '__root__'
    | '/_auth'
    | '/force-password-change'
    | '/maintenance'
    | '/_auth/approvals'
    | '/_auth/instructions'
    | '/_auth/operations'
    | '/_auth/payouts'
    | '/_public/apps'
    | '/_public/forgot-password'
    | '/_public/login'
    | '/_public/privacy'
    | '/_public/reset-password'
    | '/_public/terms'
    | '/_auth/'
    | '/_auth/accounting/accounts'
    | '/_auth/accounting/commission'
    | '/_auth/accounting/periods'
    | '/_auth/admin/config'
    | '/_auth/admin/health'
    | '/_auth/admin/maintenance'
    | '/_auth/agents/$id'
    | '/_auth/agents/new'
    | '/_auth/compliance/subscriber-register'
    | '/_auth/crm/$id'
    | '/_auth/crm/converted'
    | '/_auth/crm/leads'
    | '/_auth/crm/lost'
    | '/_auth/crm/new'
    | '/_auth/crm/prospects'
    | '/_auth/customers/$id'
    | '/_auth/customers/new'
    | '/_auth/defaults/$id'
    | '/_auth/finance/cash-vault'
    | '/_auth/finance/handovers'
    | '/_auth/finance/receipts'
    | '/_auth/finance/running-receipts'
    | '/_auth/ledger/$accountId'
    | '/_auth/logs/auth'
    | '/_auth/logs/notifications'
    | '/_auth/pidi-schemes/$id'
    | '/_auth/pidi-schemes/new'
    | '/_auth/reconciliation/$importId'
    | '/_auth/reports/$code'
    | '/_auth/reports/arrears'
    | '/_auth/reports/daybook'
    | '/_auth/reports/subscriber-ledger'
    | '/_auth/schemes/$id'
    | '/_auth/schemes/estimate'
    | '/_auth/schemes/new'
    | '/_auth/schemes/transfers'
    | '/_auth/settings/branches'
    | '/_auth/settings/mpin'
    | '/_auth/settings/password'
    | '/_auth/settings/roles'
    | '/_auth/settings/security'
    | '/_auth/settings/sessions'
    | '/_auth/setup/company'
    | '/_auth/templates/$id'
    | '/_auth/templates/new'
    | '/_auth/users/$id'
    | '/_auth/users/new'
    | '/_auth/agents/'
    | '/_auth/auctions/'
    | '/_auth/audit/'
    | '/_auth/customers/'
    | '/_auth/defaults/'
    | '/_auth/foreclosure/'
    | '/_auth/overdue/'
    | '/_auth/pidi-schemes/'
    | '/_auth/reports/'
    | '/_auth/schemes/'
    | '/_auth/surety/'
    | '/_auth/tax/'
    | '/_auth/templates/'
    | '/_auth/users/'
    | '/_auth/accounting/general-transactions/new'
    | '/_auth/admin/products/new'
    | '/_auth/admin/staff/$id'
    | '/_auth/admin/staff/new'
    | '/_auth/finance/advances/new'
    | '/_auth/finance/cheque-register/new'
    | '/_auth/finance/chit-act-fees/new'
    | '/_auth/finance/decrees/new'
    | '/_auth/finance/group-deposits/new'
    | '/_auth/finance/receipt-vouchers/new'
    | '/_auth/finance/write-offs/new'
    | '/_auth/reports/financial/balance-sheet'
    | '/_auth/reports/financial/pnl'
    | '/_auth/reports/financial/trial-balance'
    | '/_auth/reports/operational/collections'
    | '/_auth/reports/operational/staff-activity'
    | '/_auth/schemes/$id/commission'
    | '/_auth/settings/areas/new'
    | '/_auth/settings/areas/new-group'
    | '/_auth/settings/devices/new'
    | '/_auth/settings/fee-slabs/new'
    | '/_auth/settings/holidays/new'
    | '/_auth/settings/notifications/templates'
    | '/_auth/accounting/general-transactions/'
    | '/_auth/accounting/journal/'
    | '/_auth/admin/products/'
    | '/_auth/admin/staff/'
    | '/_auth/finance/advances/'
    | '/_auth/finance/cheque-register/'
    | '/_auth/finance/chit-act-fees/'
    | '/_auth/finance/decrees/'
    | '/_auth/finance/group-deposits/'
    | '/_auth/finance/receipt-vouchers/'
    | '/_auth/finance/write-offs/'
    | '/_auth/schemes/$id/'
    | '/_auth/settings/areas/'
    | '/_auth/settings/devices/'
    | '/_auth/settings/fee-slabs/'
    | '/_auth/settings/holidays/'
    | '/_auth/surety/$id/'
    | '/_auth/audit/resource/$type/$id'
    | '/_auth/finance/payments/$id/status'
    | '/_auth/finance/write-offs/$id/recover'
    | '/_auth/settings/devices/$id/dispatch'
    | '/_auth/surety/$id/nominees/new'
    | '/_auth/schemes/$id/cycles/$num/auction'
    | '/_auth/schemes/$id/cycles/$num/dues'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthRoute: typeof AuthRouteWithChildren
  ForcePasswordChangeRoute: typeof ForcePasswordChangeRoute
  MaintenanceRoute: typeof MaintenanceRoute
  PublicAppsRoute: typeof PublicAppsRoute
  PublicForgotPasswordRoute: typeof PublicForgotPasswordRoute
  PublicLoginRoute: typeof PublicLoginRoute
  PublicPrivacyRoute: typeof PublicPrivacyRoute
  PublicResetPasswordRoute: typeof PublicResetPasswordRoute
  PublicTermsRoute: typeof PublicTermsRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/force-password-change': {
      id: '/force-password-change'
      path: '/force-password-change'
      fullPath: '/force-password-change'
      preLoaderRoute: typeof ForcePasswordChangeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/maintenance': {
      id: '/maintenance'
      path: '/maintenance'
      fullPath: '/maintenance'
      preLoaderRoute: typeof MaintenanceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/': {
      id: '/_auth/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/approvals': {
      id: '/_auth/approvals'
      path: '/approvals'
      fullPath: '/approvals'
      preLoaderRoute: typeof AuthApprovalsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/instructions': {
      id: '/_auth/instructions'
      path: '/instructions'
      fullPath: '/instructions'
      preLoaderRoute: typeof AuthInstructionsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/operations': {
      id: '/_auth/operations'
      path: '/operations'
      fullPath: '/operations'
      preLoaderRoute: typeof AuthOperationsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/payouts': {
      id: '/_auth/payouts'
      path: '/payouts'
      fullPath: '/payouts'
      preLoaderRoute: typeof AuthPayoutsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_public/apps': {
      id: '/_public/apps'
      path: '/apps'
      fullPath: '/apps'
      preLoaderRoute: typeof PublicAppsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public/forgot-password': {
      id: '/_public/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof PublicForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public/login': {
      id: '/_public/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof PublicLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public/privacy': {
      id: '/_public/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PublicPrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public/reset-password': {
      id: '/_public/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof PublicResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public/terms': {
      id: '/_public/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof PublicTermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/accounting/accounts': {
      id: '/_auth/accounting/accounts'
      path: '/accounting/accounts'
      fullPath: '/accounting/accounts'
      preLoaderRoute: typeof AuthAccountingAccountsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/accounting/commission': {
      id: '/_auth/accounting/commission'
      path: '/accounting/commission'
      fullPath: '/accounting/commission'
      preLoaderRoute: typeof AuthAccountingCommissionRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/accounting/periods': {
      id: '/_auth/accounting/periods'
      path: '/accounting/periods'
      fullPath: '/accounting/periods'
      preLoaderRoute: typeof AuthAccountingPeriodsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/admin/config': {
      id: '/_auth/admin/config'
      path: '/admin/config'
      fullPath: '/admin/config'
      preLoaderRoute: typeof AuthAdminConfigRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/admin/health': {
      id: '/_auth/admin/health'
      path: '/admin/health'
      fullPath: '/admin/health'
      preLoaderRoute: typeof AuthAdminHealthRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/admin/maintenance': {
      id: '/_auth/admin/maintenance'
      path: '/admin/maintenance'
      fullPath: '/admin/maintenance'
      preLoaderRoute: typeof AuthAdminMaintenanceRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/agents/': {
      id: '/_auth/agents/'
      path: '/agents'
      fullPath: '/agents/'
      preLoaderRoute: typeof AuthAgentsIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/agents/$id': {
      id: '/_auth/agents/$id'
      path: '/agents/$id'
      fullPath: '/agents/$id'
      preLoaderRoute: typeof AuthAgentsIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/agents/new': {
      id: '/_auth/agents/new'
      path: '/agents/new'
      fullPath: '/agents/new'
      preLoaderRoute: typeof AuthAgentsNewRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/auctions/': {
      id: '/_auth/auctions/'
      path: '/auctions'
      fullPath: '/auctions/'
      preLoaderRoute: typeof AuthAuctionsIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/audit/': {
      id: '/_auth/audit/'
      path: '/audit'
      fullPath: '/audit/'
      preLoaderRoute: typeof AuthAuditIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/compliance/subscriber-register': {
      id: '/_auth/compliance/subscriber-register'
      path: '/compliance/subscriber-register'
      fullPath: '/compliance/subscriber-register'
      preLoaderRoute: typeof AuthComplianceSubscriberRegisterRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/crm/$id': {
      id: '/_auth/crm/$id'
      path: '/crm/$id'
      fullPath: '/crm/$id'
      preLoaderRoute: typeof AuthCrmIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/crm/converted': {
      id: '/_auth/crm/converted'
      path: '/crm/converted'
      fullPath: '/crm/converted'
      preLoaderRoute: typeof AuthCrmConvertedRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/crm/leads': {
      id: '/_auth/crm/leads'
      path: '/crm/leads'
      fullPath: '/crm/leads'
      preLoaderRoute: typeof AuthCrmLeadsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/crm/lost': {
      id: '/_auth/crm/lost'
      path: '/crm/lost'
      fullPath: '/crm/lost'
      preLoaderRoute: typeof AuthCrmLostRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/crm/new': {
      id: '/_auth/crm/new'
      path: '/crm/new'
      fullPath: '/crm/new'
      preLoaderRoute: typeof AuthCrmNewRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/crm/prospects': {
      id: '/_auth/crm/prospects'
      path: '/crm/prospects'
      fullPath: '/crm/prospects'
      preLoaderRoute: typeof AuthCrmProspectsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/customers/': {
      id: '/_auth/customers/'
      path: '/customers'
      fullPath: '/customers/'
      preLoaderRoute: typeof AuthCustomersIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/customers/$id': {
      id: '/_auth/customers/$id'
      path: '/customers/$id'
      fullPath: '/customers/$id'
      preLoaderRoute: typeof AuthCustomersIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/customers/new': {
      id: '/_auth/customers/new'
      path: '/customers/new'
      fullPath: '/customers/new'
      preLoaderRoute: typeof AuthCustomersNewRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/defaults/': {
      id: '/_auth/defaults/'
      path: '/defaults'
      fullPath: '/defaults/'
      preLoaderRoute: typeof AuthDefaultsIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/defaults/$id': {
      id: '/_auth/defaults/$id'
      path: '/defaults/$id'
      fullPath: '/defaults/$id'
      preLoaderRoute: typeof AuthDefaultsIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/finance/cash-vault': {
      id: '/_auth/finance/cash-vault'
      path: '/finance/cash-vault'
      fullPath: '/finance/cash-vault'
      preLoaderRoute: typeof AuthFinanceCashVaultRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/finance/handovers': {
      id: '/_auth/finance/handovers'
      path: '/finance/handovers'
      fullPath: '/finance/handovers'
      preLoaderRoute: typeof AuthFinanceHandoversRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/finance/receipts': {
      id: '/_auth/finance/receipts'
      path: '/finance/receipts'
      fullPath: '/finance/receipts'
      preLoaderRoute: typeof AuthFinanceReceiptsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/finance/running-receipts': {
      id: '/_auth/finance/running-receipts'
      path: '/finance/running-receipts'
      fullPath: '/finance/running-receipts'
      preLoaderRoute: typeof AuthFinanceRunningReceiptsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/foreclosure/': {
      id: '/_auth/foreclosure/'
      path: '/foreclosure'
      fullPath: '/foreclosure/'
      preLoaderRoute: typeof AuthForeclosureIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/ledger/$accountId': {
      id: '/_auth/ledger/$accountId'
      path: '/ledger/$accountId'
      fullPath: '/ledger/$accountId'
      preLoaderRoute: typeof AuthLedgerAccountIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/logs/auth': {
      id: '/_auth/logs/auth'
      path: '/logs/auth'
      fullPath: '/logs/auth'
      preLoaderRoute: typeof AuthLogsAuthRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/logs/notifications': {
      id: '/_auth/logs/notifications'
      path: '/logs/notifications'
      fullPath: '/logs/notifications'
      preLoaderRoute: typeof AuthLogsNotificationsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/overdue/': {
      id: '/_auth/overdue/'
      path: '/overdue'
      fullPath: '/overdue/'
      preLoaderRoute: typeof AuthOverdueIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/pidi-schemes/': {
      id: '/_auth/pidi-schemes/'
      path: '/pidi-schemes'
      fullPath: '/pidi-schemes/'
      preLoaderRoute: typeof AuthPidiSchemesIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/pidi-schemes/$id': {
      id: '/_auth/pidi-schemes/$id'
      path: '/pidi-schemes/$id'
      fullPath: '/pidi-schemes/$id'
      preLoaderRoute: typeof AuthPidiSchemesIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/pidi-schemes/new': {
      id: '/_auth/pidi-schemes/new'
      path: '/pidi-schemes/new'
      fullPath: '/pidi-schemes/new'
      preLoaderRoute: typeof AuthPidiSchemesNewRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/reconciliation/$importId': {
      id: '/_auth/reconciliation/$importId'
      path: '/reconciliation/$importId'
      fullPath: '/reconciliation/$importId'
      preLoaderRoute: typeof AuthReconciliationImportIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/reports/': {
      id: '/_auth/reports/'
      path: '/reports'
      fullPath: '/reports/'
      preLoaderRoute: typeof AuthReportsIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/reports/$code': {
      id: '/_auth/reports/$code'
      path: '/reports/$code'
      fullPath: '/reports/$code'
      preLoaderRoute: typeof AuthReportsCodeRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/reports/arrears': {
      id: '/_auth/reports/arrears'
      path: '/reports/arrears'
      fullPath: '/reports/arrears'
      preLoaderRoute: typeof AuthReportsArrearsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/reports/daybook': {
      id: '/_auth/reports/daybook'
      path: '/reports/daybook'
      fullPath: '/reports/daybook'
      preLoaderRoute: typeof AuthReportsDaybookRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/reports/subscriber-ledger': {
      id: '/_auth/reports/subscriber-ledger'
      path: '/reports/subscriber-ledger'
      fullPath: '/reports/subscriber-ledger'
      preLoaderRoute: typeof AuthReportsSubscriberLedgerRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/schemes/': {
      id: '/_auth/schemes/'
      path: '/schemes'
      fullPath: '/schemes/'
      preLoaderRoute: typeof AuthSchemesIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/schemes/$id': {
      id: '/_auth/schemes/$id'
      path: '/schemes/$id'
      fullPath: '/schemes/$id'
      preLoaderRoute: typeof AuthSchemesIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/schemes/estimate': {
      id: '/_auth/schemes/estimate'
      path: '/schemes/estimate'
      fullPath: '/schemes/estimate'
      preLoaderRoute: typeof AuthSchemesEstimateRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/schemes/new': {
      id: '/_auth/schemes/new'
      path: '/schemes/new'
      fullPath: '/schemes/new'
      preLoaderRoute: typeof AuthSchemesNewRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/schemes/transfers': {
      id: '/_auth/schemes/transfers'
      path: '/schemes/transfers'
      fullPath: '/schemes/transfers'
      preLoaderRoute: typeof AuthSchemesTransfersRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/settings/branches': {
      id: '/_auth/settings/branches'
      path: '/settings/branches'
      fullPath: '/settings/branches'
      preLoaderRoute: typeof AuthSettingsBranchesRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/settings/mpin': {
      id: '/_auth/settings/mpin'
      path: '/settings/mpin'
      fullPath: '/settings/mpin'
      preLoaderRoute: typeof AuthSettingsMpinRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/settings/password': {
      id: '/_auth/settings/password'
      path: '/settings/password'
      fullPath: '/settings/password'
      preLoaderRoute: typeof AuthSettingsPasswordRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/settings/roles': {
      id: '/_auth/settings/roles'
      path: '/settings/roles'
      fullPath: '/settings/roles'
      preLoaderRoute: typeof AuthSettingsRolesRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/settings/security': {
      id: '/_auth/settings/security'
      path: '/settings/security'
      fullPath: '/settings/security'
      preLoaderRoute: typeof AuthSettingsSecurityRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/settings/sessions': {
      id: '/_auth/settings/sessions'
      path: '/settings/sessions'
      fullPath: '/settings/sessions'
      preLoaderRoute: typeof AuthSettingsSessionsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/setup/company': {
      id: '/_auth/setup/company'
      path: '/setup/company'
      fullPath: '/setup/company'
      preLoaderRoute: typeof AuthSetupCompanyRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/surety/': {
      id: '/_auth/surety/'
      path: '/surety'
      fullPath: '/surety/'
      preLoaderRoute: typeof AuthSuretyIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/tax/': {
      id: '/_auth/tax/'
      path: '/tax'
      fullPath: '/tax/'
      preLoaderRoute: typeof AuthTaxIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/templates/': {
      id: '/_auth/templates/'
      path: '/templates'
      fullPath: '/templates/'
      preLoaderRoute: typeof AuthTemplatesIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/templates/$id': {
      id: '/_auth/templates/$id'
      path: '/templates/$id'
      fullPath: '/templates/$id'
      preLoaderRoute: typeof AuthTemplatesIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/templates/new': {
      id: '/_auth/templates/new'
      path: '/templates/new'
      fullPath: '/templates/new'
      preLoaderRoute: typeof AuthTemplatesNewRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/users/': {
      id: '/_auth/users/'
      path: '/users'
      fullPath: '/users/'
      preLoaderRoute: typeof AuthUsersIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/users/$id': {
      id: '/_auth/users/$id'
      path: '/users/$id'
      fullPath: '/users/$id'
      preLoaderRoute: typeof AuthUsersIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/users/new': {
      id: '/_auth/users/new'
      path: '/users/new'
      fullPath: '/users/new'
      preLoaderRoute: typeof AuthUsersNewRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/accounting/general-transactions/': {
      id: '/_auth/accounting/general-transactions/'
      path: '/accounting/general-transactions'
      fullPath: '/accounting/general-transactions/'
      preLoaderRoute: typeof AuthAccountingGeneralTransactionsIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/accounting/general-transactions/new': {
      id: '/_auth/accounting/general-transactions/new'
      path: '/accounting/general-transactions/new'
      fullPath: '/accounting/general-transactions/new'
      preLoaderRoute: typeof AuthAccountingGeneralTransactionsNewRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/accounting/journal/': {
      id: '/_auth/accounting/journal/'
      path: '/accounting/journal'
      fullPath: '/accounting/journal/'
      preLoaderRoute: typeof AuthAccountingJournalIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/admin/products/': {
      id: '/_auth/admin/products/'
      path: '/admin/products'
      fullPath: '/admin/products/'
      preLoaderRoute: typeof AuthAdminProductsIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/admin/products/new': {
      id: '/_auth/admin/products/new'
      path: '/admin/products/new'
      fullPath: '/admin/products/new'
      preLoaderRoute: typeof AuthAdminProductsNewRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/admin/staff/': {
      id: '/_auth/admin/staff/'
      path: '/admin/staff'
      fullPath: '/admin/staff/'
      preLoaderRoute: typeof AuthAdminStaffIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/admin/staff/$id': {
      id: '/_auth/admin/staff/$id'
      path: '/admin/staff/$id'
      fullPath: '/admin/staff/$id'
      preLoaderRoute: typeof AuthAdminStaffIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/admin/staff/new': {
      id: '/_auth/admin/staff/new'
      path: '/admin/staff/new'
      fullPath: '/admin/staff/new'
      preLoaderRoute: typeof AuthAdminStaffNewRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/finance/advances/': {
      id: '/_auth/finance/advances/'
      path: '/finance/advances'
      fullPath: '/finance/advances/'
      preLoaderRoute: typeof AuthFinanceAdvancesIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/finance/advances/new': {
      id: '/_auth/finance/advances/new'
      path: '/finance/advances/new'
      fullPath: '/finance/advances/new'
      preLoaderRoute: typeof AuthFinanceAdvancesNewRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/finance/cheque-register/': {
      id: '/_auth/finance/cheque-register/'
      path: '/finance/cheque-register'
      fullPath: '/finance/cheque-register/'
      preLoaderRoute: typeof AuthFinanceChequeRegisterIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/finance/cheque-register/new': {
      id: '/_auth/finance/cheque-register/new'
      path: '/finance/cheque-register/new'
      fullPath: '/finance/cheque-register/new'
      preLoaderRoute: typeof AuthFinanceChequeRegisterNewRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/finance/chit-act-fees/': {
      id: '/_auth/finance/chit-act-fees/'
      path: '/finance/chit-act-fees'
      fullPath: '/finance/chit-act-fees/'
      preLoaderRoute: typeof AuthFinanceChitActFeesIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/finance/chit-act-fees/new': {
      id: '/_auth/finance/chit-act-fees/new'
      path: '/finance/chit-act-fees/new'
      fullPath: '/finance/chit-act-fees/new'
      preLoaderRoute: typeof AuthFinanceChitActFeesNewRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/finance/decrees/': {
      id: '/_auth/finance/decrees/'
      path: '/finance/decrees'
      fullPath: '/finance/decrees/'
      preLoaderRoute: typeof AuthFinanceDecreesIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/finance/decrees/new': {
      id: '/_auth/finance/decrees/new'
      path: '/finance/decrees/new'
      fullPath: '/finance/decrees/new'
      preLoaderRoute: typeof AuthFinanceDecreesNewRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/finance/group-deposits/': {
      id: '/_auth/finance/group-deposits/'
      path: '/finance/group-deposits'
      fullPath: '/finance/group-deposits/'
      preLoaderRoute: typeof AuthFinanceGroupDepositsIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/finance/group-deposits/new': {
      id: '/_auth/finance/group-deposits/new'
      path: '/finance/group-deposits/new'
      fullPath: '/finance/group-deposits/new'
      preLoaderRoute: typeof AuthFinanceGroupDepositsNewRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/finance/receipt-vouchers/': {
      id: '/_auth/finance/receipt-vouchers/'
      path: '/finance/receipt-vouchers'
      fullPath: '/finance/receipt-vouchers/'
      preLoaderRoute: typeof AuthFinanceReceiptVouchersIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/finance/receipt-vouchers/new': {
      id: '/_auth/finance/receipt-vouchers/new'
      path: '/finance/receipt-vouchers/new'
      fullPath: '/finance/receipt-vouchers/new'
      preLoaderRoute: typeof AuthFinanceReceiptVouchersNewRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/finance/write-offs/': {
      id: '/_auth/finance/write-offs/'
      path: '/finance/write-offs'
      fullPath: '/finance/write-offs/'
      preLoaderRoute: typeof AuthFinanceWriteOffsIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/finance/write-offs/new': {
      id: '/_auth/finance/write-offs/new'
      path: '/finance/write-offs/new'
      fullPath: '/finance/write-offs/new'
      preLoaderRoute: typeof AuthFinanceWriteOffsNewRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/reports/financial/balance-sheet': {
      id: '/_auth/reports/financial/balance-sheet'
      path: '/reports/financial/balance-sheet'
      fullPath: '/reports/financial/balance-sheet'
      preLoaderRoute: typeof AuthReportsFinancialBalanceSheetRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/reports/financial/pnl': {
      id: '/_auth/reports/financial/pnl'
      path: '/reports/financial/pnl'
      fullPath: '/reports/financial/pnl'
      preLoaderRoute: typeof AuthReportsFinancialPnlRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/reports/financial/trial-balance': {
      id: '/_auth/reports/financial/trial-balance'
      path: '/reports/financial/trial-balance'
      fullPath: '/reports/financial/trial-balance'
      preLoaderRoute: typeof AuthReportsFinancialTrialBalanceRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/reports/operational/collections': {
      id: '/_auth/reports/operational/collections'
      path: '/reports/operational/collections'
      fullPath: '/reports/operational/collections'
      preLoaderRoute: typeof AuthReportsOperationalCollectionsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/reports/operational/staff-activity': {
      id: '/_auth/reports/operational/staff-activity'
      path: '/reports/operational/staff-activity'
      fullPath: '/reports/operational/staff-activity'
      preLoaderRoute: typeof AuthReportsOperationalStaffActivityRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/schemes/$id/': {
      id: '/_auth/schemes/$id/'
      path: '/'
      fullPath: '/schemes/$id/'
      preLoaderRoute: typeof AuthSchemesIdIndexRouteImport
      parentRoute: typeof AuthSchemesIdRoute
    }
    '/_auth/schemes/$id/commission': {
      id: '/_auth/schemes/$id/commission'
      path: '/commission'
      fullPath: '/schemes/$id/commission'
      preLoaderRoute: typeof AuthSchemesIdCommissionRouteImport
      parentRoute: typeof AuthSchemesIdRoute
    }
    '/_auth/settings/areas/': {
      id: '/_auth/settings/areas/'
      path: '/settings/areas'
      fullPath: '/settings/areas/'
      preLoaderRoute: typeof AuthSettingsAreasIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/settings/areas/new': {
      id: '/_auth/settings/areas/new'
      path: '/settings/areas/new'
      fullPath: '/settings/areas/new'
      preLoaderRoute: typeof AuthSettingsAreasNewRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/settings/areas/new-group': {
      id: '/_auth/settings/areas/new-group'
      path: '/settings/areas/new-group'
      fullPath: '/settings/areas/new-group'
      preLoaderRoute: typeof AuthSettingsAreasNewGroupRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/settings/devices/': {
      id: '/_auth/settings/devices/'
      path: '/settings/devices'
      fullPath: '/settings/devices/'
      preLoaderRoute: typeof AuthSettingsDevicesIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/settings/devices/new': {
      id: '/_auth/settings/devices/new'
      path: '/settings/devices/new'
      fullPath: '/settings/devices/new'
      preLoaderRoute: typeof AuthSettingsDevicesNewRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/settings/fee-slabs/': {
      id: '/_auth/settings/fee-slabs/'
      path: '/settings/fee-slabs'
      fullPath: '/settings/fee-slabs/'
      preLoaderRoute: typeof AuthSettingsFeeSlabsIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/settings/fee-slabs/new': {
      id: '/_auth/settings/fee-slabs/new'
      path: '/settings/fee-slabs/new'
      fullPath: '/settings/fee-slabs/new'
      preLoaderRoute: typeof AuthSettingsFeeSlabsNewRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/settings/holidays/': {
      id: '/_auth/settings/holidays/'
      path: '/settings/holidays'
      fullPath: '/settings/holidays/'
      preLoaderRoute: typeof AuthSettingsHolidaysIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/settings/holidays/new': {
      id: '/_auth/settings/holidays/new'
      path: '/settings/holidays/new'
      fullPath: '/settings/holidays/new'
      preLoaderRoute: typeof AuthSettingsHolidaysNewRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/settings/notifications/templates': {
      id: '/_auth/settings/notifications/templates'
      path: '/settings/notifications/templates'
      fullPath: '/settings/notifications/templates'
      preLoaderRoute: typeof AuthSettingsNotificationsTemplatesRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/surety/$id/': {
      id: '/_auth/surety/$id/'
      path: '/surety/$id'
      fullPath: '/surety/$id/'
      preLoaderRoute: typeof AuthSuretyIdIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/audit/resource/$type/$id': {
      id: '/_auth/audit/resource/$type/$id'
      path: '/audit/resource/$type/$id'
      fullPath: '/audit/resource/$type/$id'
      preLoaderRoute: typeof AuthAuditResourceTypeIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/finance/payments/$id/status': {
      id: '/_auth/finance/payments/$id/status'
      path: '/finance/payments/$id/status'
      fullPath: '/finance/payments/$id/status'
      preLoaderRoute: typeof AuthFinancePaymentsIdStatusRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/finance/write-offs/$id/recover': {
      id: '/_auth/finance/write-offs/$id/recover'
      path: '/finance/write-offs/$id/recover'
      fullPath: '/finance/write-offs/$id/recover'
      preLoaderRoute: typeof AuthFinanceWriteOffsIdRecoverRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/settings/devices/$id/dispatch': {
      id: '/_auth/settings/devices/$id/dispatch'
      path: '/settings/devices/$id/dispatch'
      fullPath: '/settings/devices/$id/dispatch'
      preLoaderRoute: typeof AuthSettingsDevicesIdDispatchRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/surety/$id/nominees/new': {
      id: '/_auth/surety/$id/nominees/new'
      path: '/surety/$id/nominees/new'
      fullPath: '/surety/$id/nominees/new'
      preLoaderRoute: typeof AuthSuretyIdNomineesNewRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/schemes/$id/cycles/$num/auction': {
      id: '/_auth/schemes/$id/cycles/$num/auction'
      path: '/cycles/$num/auction'
      fullPath: '/schemes/$id/cycles/$num/auction'
      preLoaderRoute: typeof AuthSchemesIdCyclesNumAuctionRouteImport
      parentRoute: typeof AuthSchemesIdRoute
    }
    '/_auth/schemes/$id/cycles/$num/dues': {
      id: '/_auth/schemes/$id/cycles/$num/dues'
      path: '/cycles/$num/dues'
      fullPath: '/schemes/$id/cycles/$num/dues'
      preLoaderRoute: typeof AuthSchemesIdCyclesNumDuesRouteImport
      parentRoute: typeof AuthSchemesIdRoute
    }
  }
}

interface AuthSchemesIdRouteChildren {
  AuthSchemesIdCommissionRoute: typeof AuthSchemesIdCommissionRoute
  AuthSchemesIdIndexRoute: typeof AuthSchemesIdIndexRoute
  AuthSchemesIdCyclesNumAuctionRoute: typeof AuthSchemesIdCyclesNumAuctionRoute
  AuthSchemesIdCyclesNumDuesRoute: typeof AuthSchemesIdCyclesNumDuesRoute
}

const AuthSchemesIdRouteChildren: AuthSchemesIdRouteChildren = {
  AuthSchemesIdCommissionRoute: AuthSchemesIdCommissionRoute,
  AuthSchemesIdIndexRoute: AuthSchemesIdIndexRoute,
  AuthSchemesIdCyclesNumAuctionRoute: AuthSchemesIdCyclesNumAuctionRoute,
  AuthSchemesIdCyclesNumDuesRoute: AuthSchemesIdCyclesNumDuesRoute,
}

const AuthSchemesIdRouteWithChildren = AuthSchemesIdRoute._addFileChildren(
  AuthSchemesIdRouteChildren,
)

interface AuthRouteChildren {
  AuthApprovalsRoute: typeof AuthApprovalsRoute
  AuthInstructionsRoute: typeof AuthInstructionsRoute
  AuthOperationsRoute: typeof AuthOperationsRoute
  AuthPayoutsRoute: typeof AuthPayoutsRoute
  AuthIndexRoute: typeof AuthIndexRoute
  AuthAccountingAccountsRoute: typeof AuthAccountingAccountsRoute
  AuthAccountingCommissionRoute: typeof AuthAccountingCommissionRoute
  AuthAccountingPeriodsRoute: typeof AuthAccountingPeriodsRoute
  AuthAdminConfigRoute: typeof AuthAdminConfigRoute
  AuthAdminHealthRoute: typeof AuthAdminHealthRoute
  AuthAdminMaintenanceRoute: typeof AuthAdminMaintenanceRoute
  AuthAgentsIdRoute: typeof AuthAgentsIdRoute
  AuthAgentsNewRoute: typeof AuthAgentsNewRoute
  AuthComplianceSubscriberRegisterRoute: typeof AuthComplianceSubscriberRegisterRoute
  AuthCrmIdRoute: typeof AuthCrmIdRoute
  AuthCrmConvertedRoute: typeof AuthCrmConvertedRoute
  AuthCrmLeadsRoute: typeof AuthCrmLeadsRoute
  AuthCrmLostRoute: typeof AuthCrmLostRoute
  AuthCrmNewRoute: typeof AuthCrmNewRoute
  AuthCrmProspectsRoute: typeof AuthCrmProspectsRoute
  AuthCustomersIdRoute: typeof AuthCustomersIdRoute
  AuthCustomersNewRoute: typeof AuthCustomersNewRoute
  AuthDefaultsIdRoute: typeof AuthDefaultsIdRoute
  AuthFinanceCashVaultRoute: typeof AuthFinanceCashVaultRoute
  AuthFinanceHandoversRoute: typeof AuthFinanceHandoversRoute
  AuthFinanceReceiptsRoute: typeof AuthFinanceReceiptsRoute
  AuthFinanceRunningReceiptsRoute: typeof AuthFinanceRunningReceiptsRoute
  AuthLedgerAccountIdRoute: typeof AuthLedgerAccountIdRoute
  AuthLogsAuthRoute: typeof AuthLogsAuthRoute
  AuthLogsNotificationsRoute: typeof AuthLogsNotificationsRoute
  AuthPidiSchemesIdRoute: typeof AuthPidiSchemesIdRoute
  AuthPidiSchemesNewRoute: typeof AuthPidiSchemesNewRoute
  AuthReconciliationImportIdRoute: typeof AuthReconciliationImportIdRoute
  AuthReportsCodeRoute: typeof AuthReportsCodeRoute
  AuthReportsArrearsRoute: typeof AuthReportsArrearsRoute
  AuthReportsDaybookRoute: typeof AuthReportsDaybookRoute
  AuthReportsSubscriberLedgerRoute: typeof AuthReportsSubscriberLedgerRoute
  AuthSchemesIdRoute: typeof AuthSchemesIdRouteWithChildren
  AuthSchemesEstimateRoute: typeof AuthSchemesEstimateRoute
  AuthSchemesNewRoute: typeof AuthSchemesNewRoute
  AuthSchemesTransfersRoute: typeof AuthSchemesTransfersRoute
  AuthSettingsBranchesRoute: typeof AuthSettingsBranchesRoute
  AuthSettingsMpinRoute: typeof AuthSettingsMpinRoute
  AuthSettingsPasswordRoute: typeof AuthSettingsPasswordRoute
  AuthSettingsRolesRoute: typeof AuthSettingsRolesRoute
  AuthSettingsSecurityRoute: typeof AuthSettingsSecurityRoute
  AuthSettingsSessionsRoute: typeof AuthSettingsSessionsRoute
  AuthSetupCompanyRoute: typeof AuthSetupCompanyRoute
  AuthTemplatesIdRoute: typeof AuthTemplatesIdRoute
  AuthTemplatesNewRoute: typeof AuthTemplatesNewRoute
  AuthUsersIdRoute: typeof AuthUsersIdRoute
  AuthUsersNewRoute: typeof AuthUsersNewRoute
  AuthAgentsIndexRoute: typeof AuthAgentsIndexRoute
  AuthAuctionsIndexRoute: typeof AuthAuctionsIndexRoute
  AuthAuditIndexRoute: typeof AuthAuditIndexRoute
  AuthCustomersIndexRoute: typeof AuthCustomersIndexRoute
  AuthDefaultsIndexRoute: typeof AuthDefaultsIndexRoute
  AuthForeclosureIndexRoute: typeof AuthForeclosureIndexRoute
  AuthOverdueIndexRoute: typeof AuthOverdueIndexRoute
  AuthPidiSchemesIndexRoute: typeof AuthPidiSchemesIndexRoute
  AuthReportsIndexRoute: typeof AuthReportsIndexRoute
  AuthSchemesIndexRoute: typeof AuthSchemesIndexRoute
  AuthSuretyIndexRoute: typeof AuthSuretyIndexRoute
  AuthTaxIndexRoute: typeof AuthTaxIndexRoute
  AuthTemplatesIndexRoute: typeof AuthTemplatesIndexRoute
  AuthUsersIndexRoute: typeof AuthUsersIndexRoute
  AuthAccountingGeneralTransactionsNewRoute: typeof AuthAccountingGeneralTransactionsNewRoute
  AuthAdminProductsNewRoute: typeof AuthAdminProductsNewRoute
  AuthAdminStaffIdRoute: typeof AuthAdminStaffIdRoute
  AuthAdminStaffNewRoute: typeof AuthAdminStaffNewRoute
  AuthFinanceAdvancesNewRoute: typeof AuthFinanceAdvancesNewRoute
  AuthFinanceChequeRegisterNewRoute: typeof AuthFinanceChequeRegisterNewRoute
  AuthFinanceChitActFeesNewRoute: typeof AuthFinanceChitActFeesNewRoute
  AuthFinanceDecreesNewRoute: typeof AuthFinanceDecreesNewRoute
  AuthFinanceGroupDepositsNewRoute: typeof AuthFinanceGroupDepositsNewRoute
  AuthFinanceReceiptVouchersNewRoute: typeof AuthFinanceReceiptVouchersNewRoute
  AuthFinanceWriteOffsNewRoute: typeof AuthFinanceWriteOffsNewRoute
  AuthReportsFinancialBalanceSheetRoute: typeof AuthReportsFinancialBalanceSheetRoute
  AuthReportsFinancialPnlRoute: typeof AuthReportsFinancialPnlRoute
  AuthReportsFinancialTrialBalanceRoute: typeof AuthReportsFinancialTrialBalanceRoute
  AuthReportsOperationalCollectionsRoute: typeof AuthReportsOperationalCollectionsRoute
  AuthReportsOperationalStaffActivityRoute: typeof AuthReportsOperationalStaffActivityRoute
  AuthSettingsAreasNewRoute: typeof AuthSettingsAreasNewRoute
  AuthSettingsAreasNewGroupRoute: typeof AuthSettingsAreasNewGroupRoute
  AuthSettingsDevicesNewRoute: typeof AuthSettingsDevicesNewRoute
  AuthSettingsFeeSlabsNewRoute: typeof AuthSettingsFeeSlabsNewRoute
  AuthSettingsHolidaysNewRoute: typeof AuthSettingsHolidaysNewRoute
  AuthSettingsNotificationsTemplatesRoute: typeof AuthSettingsNotificationsTemplatesRoute
  AuthAccountingGeneralTransactionsIndexRoute: typeof AuthAccountingGeneralTransactionsIndexRoute
  AuthAccountingJournalIndexRoute: typeof AuthAccountingJournalIndexRoute
  AuthAdminProductsIndexRoute: typeof AuthAdminProductsIndexRoute
  AuthAdminStaffIndexRoute: typeof AuthAdminStaffIndexRoute
  AuthFinanceAdvancesIndexRoute: typeof AuthFinanceAdvancesIndexRoute
  AuthFinanceChequeRegisterIndexRoute: typeof AuthFinanceChequeRegisterIndexRoute
  AuthFinanceChitActFeesIndexRoute: typeof AuthFinanceChitActFeesIndexRoute
  AuthFinanceDecreesIndexRoute: typeof AuthFinanceDecreesIndexRoute
  AuthFinanceGroupDepositsIndexRoute: typeof AuthFinanceGroupDepositsIndexRoute
  AuthFinanceReceiptVouchersIndexRoute: typeof AuthFinanceReceiptVouchersIndexRoute
  AuthFinanceWriteOffsIndexRoute: typeof AuthFinanceWriteOffsIndexRoute
  AuthSettingsAreasIndexRoute: typeof AuthSettingsAreasIndexRoute
  AuthSettingsDevicesIndexRoute: typeof AuthSettingsDevicesIndexRoute
  AuthSettingsFeeSlabsIndexRoute: typeof AuthSettingsFeeSlabsIndexRoute
  AuthSettingsHolidaysIndexRoute: typeof AuthSettingsHolidaysIndexRoute
  AuthSuretyIdIndexRoute: typeof AuthSuretyIdIndexRoute
  AuthAuditResourceTypeIdRoute: typeof AuthAuditResourceTypeIdRoute
  AuthFinancePaymentsIdStatusRoute: typeof AuthFinancePaymentsIdStatusRoute
  AuthFinanceWriteOffsIdRecoverRoute: typeof AuthFinanceWriteOffsIdRecoverRoute
  AuthSettingsDevicesIdDispatchRoute: typeof AuthSettingsDevicesIdDispatchRoute
  AuthSuretyIdNomineesNewRoute: typeof AuthSuretyIdNomineesNewRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthApprovalsRoute: AuthApprovalsRoute,
  AuthInstructionsRoute: AuthInstructionsRoute,
  AuthOperationsRoute: AuthOperationsRoute,
  AuthPayoutsRoute: AuthPayoutsRoute,
  AuthIndexRoute: AuthIndexRoute,
  AuthAccountingAccountsRoute: AuthAccountingAccountsRoute,
  AuthAccountingCommissionRoute: AuthAccountingCommissionRoute,
  AuthAccountingPeriodsRoute: AuthAccountingPeriodsRoute,
  AuthAdminConfigRoute: AuthAdminConfigRoute,
  AuthAdminHealthRoute: AuthAdminHealthRoute,
  AuthAdminMaintenanceRoute: AuthAdminMaintenanceRoute,
  AuthAgentsIdRoute: AuthAgentsIdRoute,
  AuthAgentsNewRoute: AuthAgentsNewRoute,
  AuthComplianceSubscriberRegisterRoute: AuthComplianceSubscriberRegisterRoute,
  AuthCrmIdRoute: AuthCrmIdRoute,
  AuthCrmConvertedRoute: AuthCrmConvertedRoute,
  AuthCrmLeadsRoute: AuthCrmLeadsRoute,
  AuthCrmLostRoute: AuthCrmLostRoute,
  AuthCrmNewRoute: AuthCrmNewRoute,
  AuthCrmProspectsRoute: AuthCrmProspectsRoute,
  AuthCustomersIdRoute: AuthCustomersIdRoute,
  AuthCustomersNewRoute: AuthCustomersNewRoute,
  AuthDefaultsIdRoute: AuthDefaultsIdRoute,
  AuthFinanceCashVaultRoute: AuthFinanceCashVaultRoute,
  AuthFinanceHandoversRoute: AuthFinanceHandoversRoute,
  AuthFinanceReceiptsRoute: AuthFinanceReceiptsRoute,
  AuthFinanceRunningReceiptsRoute: AuthFinanceRunningReceiptsRoute,
  AuthLedgerAccountIdRoute: AuthLedgerAccountIdRoute,
  AuthLogsAuthRoute: AuthLogsAuthRoute,
  AuthLogsNotificationsRoute: AuthLogsNotificationsRoute,
  AuthPidiSchemesIdRoute: AuthPidiSchemesIdRoute,
  AuthPidiSchemesNewRoute: AuthPidiSchemesNewRoute,
  AuthReconciliationImportIdRoute: AuthReconciliationImportIdRoute,
  AuthReportsCodeRoute: AuthReportsCodeRoute,
  AuthReportsArrearsRoute: AuthReportsArrearsRoute,
  AuthReportsDaybookRoute: AuthReportsDaybookRoute,
  AuthReportsSubscriberLedgerRoute: AuthReportsSubscriberLedgerRoute,
  AuthSchemesIdRoute: AuthSchemesIdRouteWithChildren,
  AuthSchemesEstimateRoute: AuthSchemesEstimateRoute,
  AuthSchemesNewRoute: AuthSchemesNewRoute,
  AuthSchemesTransfersRoute: AuthSchemesTransfersRoute,
  AuthSettingsBranchesRoute: AuthSettingsBranchesRoute,
  AuthSettingsMpinRoute: AuthSettingsMpinRoute,
  AuthSettingsPasswordRoute: AuthSettingsPasswordRoute,
  AuthSettingsRolesRoute: AuthSettingsRolesRoute,
  AuthSettingsSecurityRoute: AuthSettingsSecurityRoute,
  AuthSettingsSessionsRoute: AuthSettingsSessionsRoute,
  AuthSetupCompanyRoute: AuthSetupCompanyRoute,
  AuthTemplatesIdRoute: AuthTemplatesIdRoute,
  AuthTemplatesNewRoute: AuthTemplatesNewRoute,
  AuthUsersIdRoute: AuthUsersIdRoute,
  AuthUsersNewRoute: AuthUsersNewRoute,
  AuthAgentsIndexRoute: AuthAgentsIndexRoute,
  AuthAuctionsIndexRoute: AuthAuctionsIndexRoute,
  AuthAuditIndexRoute: AuthAuditIndexRoute,
  AuthCustomersIndexRoute: AuthCustomersIndexRoute,
  AuthDefaultsIndexRoute: AuthDefaultsIndexRoute,
  AuthForeclosureIndexRoute: AuthForeclosureIndexRoute,
  AuthOverdueIndexRoute: AuthOverdueIndexRoute,
  AuthPidiSchemesIndexRoute: AuthPidiSchemesIndexRoute,
  AuthReportsIndexRoute: AuthReportsIndexRoute,
  AuthSchemesIndexRoute: AuthSchemesIndexRoute,
  AuthSuretyIndexRoute: AuthSuretyIndexRoute,
  AuthTaxIndexRoute: AuthTaxIndexRoute,
  AuthTemplatesIndexRoute: AuthTemplatesIndexRoute,
  AuthUsersIndexRoute: AuthUsersIndexRoute,
  AuthAccountingGeneralTransactionsNewRoute:
    AuthAccountingGeneralTransactionsNewRoute,
  AuthAdminProductsNewRoute: AuthAdminProductsNewRoute,
  AuthAdminStaffIdRoute: AuthAdminStaffIdRoute,
  AuthAdminStaffNewRoute: AuthAdminStaffNewRoute,
  AuthFinanceAdvancesNewRoute: AuthFinanceAdvancesNewRoute,
  AuthFinanceChequeRegisterNewRoute: AuthFinanceChequeRegisterNewRoute,
  AuthFinanceChitActFeesNewRoute: AuthFinanceChitActFeesNewRoute,
  AuthFinanceDecreesNewRoute: AuthFinanceDecreesNewRoute,
  AuthFinanceGroupDepositsNewRoute: AuthFinanceGroupDepositsNewRoute,
  AuthFinanceReceiptVouchersNewRoute: AuthFinanceReceiptVouchersNewRoute,
  AuthFinanceWriteOffsNewRoute: AuthFinanceWriteOffsNewRoute,
  AuthReportsFinancialBalanceSheetRoute: AuthReportsFinancialBalanceSheetRoute,
  AuthReportsFinancialPnlRoute: AuthReportsFinancialPnlRoute,
  AuthReportsFinancialTrialBalanceRoute: AuthReportsFinancialTrialBalanceRoute,
  AuthReportsOperationalCollectionsRoute:
    AuthReportsOperationalCollectionsRoute,
  AuthReportsOperationalStaffActivityRoute:
    AuthReportsOperationalStaffActivityRoute,
  AuthSettingsAreasNewRoute: AuthSettingsAreasNewRoute,
  AuthSettingsAreasNewGroupRoute: AuthSettingsAreasNewGroupRoute,
  AuthSettingsDevicesNewRoute: AuthSettingsDevicesNewRoute,
  AuthSettingsFeeSlabsNewRoute: AuthSettingsFeeSlabsNewRoute,
  AuthSettingsHolidaysNewRoute: AuthSettingsHolidaysNewRoute,
  AuthSettingsNotificationsTemplatesRoute:
    AuthSettingsNotificationsTemplatesRoute,
  AuthAccountingGeneralTransactionsIndexRoute:
    AuthAccountingGeneralTransactionsIndexRoute,
  AuthAccountingJournalIndexRoute: AuthAccountingJournalIndexRoute,
  AuthAdminProductsIndexRoute: AuthAdminProductsIndexRoute,
  AuthAdminStaffIndexRoute: AuthAdminStaffIndexRoute,
  AuthFinanceAdvancesIndexRoute: AuthFinanceAdvancesIndexRoute,
  AuthFinanceChequeRegisterIndexRoute: AuthFinanceChequeRegisterIndexRoute,
  AuthFinanceChitActFeesIndexRoute: AuthFinanceChitActFeesIndexRoute,
  AuthFinanceDecreesIndexRoute: AuthFinanceDecreesIndexRoute,
  AuthFinanceGroupDepositsIndexRoute: AuthFinanceGroupDepositsIndexRoute,
  AuthFinanceReceiptVouchersIndexRoute: AuthFinanceReceiptVouchersIndexRoute,
  AuthFinanceWriteOffsIndexRoute: AuthFinanceWriteOffsIndexRoute,
  AuthSettingsAreasIndexRoute: AuthSettingsAreasIndexRoute,
  AuthSettingsDevicesIndexRoute: AuthSettingsDevicesIndexRoute,
  AuthSettingsFeeSlabsIndexRoute: AuthSettingsFeeSlabsIndexRoute,
  AuthSettingsHolidaysIndexRoute: AuthSettingsHolidaysIndexRoute,
  AuthSuretyIdIndexRoute: AuthSuretyIdIndexRoute,
  AuthAuditResourceTypeIdRoute: AuthAuditResourceTypeIdRoute,
  AuthFinancePaymentsIdStatusRoute: AuthFinancePaymentsIdStatusRoute,
  AuthFinanceWriteOffsIdRecoverRoute: AuthFinanceWriteOffsIdRecoverRoute,
  AuthSettingsDevicesIdDispatchRoute: AuthSettingsDevicesIdDispatchRoute,
  AuthSuretyIdNomineesNewRoute: AuthSuretyIdNomineesNewRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthRoute: AuthRouteWithChildren,
  ForcePasswordChangeRoute: ForcePasswordChangeRoute,
  MaintenanceRoute: MaintenanceRoute,
  PublicAppsRoute: PublicAppsRoute,
  PublicForgotPasswordRoute: PublicForgotPasswordRoute,
  PublicLoginRoute: PublicLoginRoute,
  PublicPrivacyRoute: PublicPrivacyRoute,
  PublicResetPasswordRoute: PublicResetPasswordRoute,
  PublicTermsRoute: PublicTermsRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
